<template>
  <!-- 弹窗右侧每个块点击显示的详情内容 -->
  <div class="block-detail">
    <!-- 公用echart图 -->
    <!-- 设施总体情况1点击，都显示echart -->
    <!-- 今日查岗，培训演练任务点击，都显示echart -->
    <div class="ecahrts-wrap" v-if="echartShow">
      <div class="head-option modal-form-wrap" style="margin-right: 0">
        <p class="block_tit title">
          {{ tableOption.title }}
        </p>
        <Select
          v-model="hostId"
          clearable
          style="width: 150px"
          placeholder="请选择主机"
          @on-change="hostSelectFn"
          v-if="tableOption.blockType == 'xfz1'"
        >
          <Option v-for="item in hostList" :value="item.id" :key="item.id">
            {{ item.name }}
          </Option>
        </Select>
      </div>
      <div id="ecahrts-wrap"></div>
    </div>
    <!-- 公用表格 -->
    <div class="modal-wrap" id="modal-wrap">
      <!-- 公用头部 -->
      <div class="option-wrap modal-form-wrap" style="margin-right: 0">
        <!-- 消防主机 -->
        <div
          class="common-option"
          v-show="
            tableOption.blockType == 'xfz' ||
            tableOption.blockType == 'xfz1' ||
            tableOption.blockType == 'xfz2'
          "
        >
          <div class="detail_tit_wrap">
            <span class="block_tit">
              {{ tableOption.title }}
            </span>
            <Button type="primary" @click="hideDetailFn">收起</Button>
          </div>
          <div class="form-wrap">
            <div class="list-wrap">
              <div class="search-group-wrap">
                <Input
                  v-model="inpVal"
                  style="width: 150px; margin-right: 10px"
                  placeholder="名称模糊搜索"
                  @on-enter="inputSearch"
                  clearable
                ></Input>
                <div class="select-wrap">
                  <Select
                    v-model="buildingId"
                    transfer
                    :word-wrap="true"
                    clearable
                    style="width: 150px; margin-right: 10px"
                    placeholder="所属建筑"
                    @on-change="buildSelectFn"
                    v-if="
                      tableOption.blockType == 'xfz1' ||
                      tableOption.blockType == 'xfz2'
                    "
                  >
                    <Option
                      v-for="item in buildList"
                      :value="item.id"
                      :key="item.id"
                    >
                      {{ item.name }}
                    </Option>
                  </Select>
                </div>
                <div class="select-wrap">
                  <Select
                    v-model="floor"
                    transfer
                    :word-wrap="true"
                    clearable
                    style="width: 150px; margin-right: 10px"
                    placeholder="楼层号"
                    @on-change="floorSelectFn"
                    v-if="
                      tableOption.blockType == 'xfz1' ||
                      tableOption.blockType == 'xfz2'
                    "
                  >
                    <Option
                      v-for="(item, index) in floorList"
                      :value="item"
                      :key="index"
                    >
                      {{ item }}
                    </Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 电气 消防水系统 独立式探测器 其他设备-->
        <div
          class="common-option"
          v-show="
            tableOption.blockType == 'dq' ||
            tableOption.blockType == 'dq1' ||
            tableOption.blockType == 'dq2' ||
            tableOption.blockType == 'xfs' ||
            tableOption.blockType == 'xfs1' ||
            tableOption.blockType == 'xfs2' ||
            tableOption.blockType == 'tc' ||
            tableOption.blockType == 'tc1' ||
            tableOption.blockType == 'tc2' ||
            tableOption.blockType == 'qt' ||
            tableOption.blockType == 'qt1' ||
            tableOption.blockType == 'qt2' ||
            tableOption.blockType == 'zdmh' ||
            tableOption.blockType == 'zdmh1' ||
            tableOption.blockType == 'zdmh2'
          "
        >
          <div class="detail_tit_wrap">
            <span class="block_tit">
              {{ tableOption.title }}
            </span>
            <Button type="primary" @click="hideDetailFn">收起</Button>
          </div>
          <div class="form-wrap">
            <div class="list-wrap">
              <div class="search-group-wrap">
                <Input
                  v-model="inpVal"
                  style="width: 150px; margin-right: 10px"
                  placeholder="名称模糊搜索"
                  @on-enter="inputSearch"
                  clearable
                ></Input>
                <div class="select-wrap">
                  <Select
                    v-model="buildingId"
                    transfer
                    :word-wrap="true"
                    clearable
                    style="width: 150px; margin-right: 10px"
                    placeholder="所属建筑"
                    @on-change="buildSelectFn"
                  >
                    <Option
                      v-for="item in buildList"
                      :value="item.id"
                      :key="item.id"
                    >
                      {{ item.name }}
                    </Option>
                  </Select>
                </div>
                <div class="select-wrap">
                  <Select
                    transfer
                    :word-wrap="true"
                    v-model="floor"
                    clearable
                    style="width: 150px; margin-right: 10px"
                    placeholder="楼层号"
                    @on-change="floorSelectFn"
                  >
                    <Option
                      v-for="(item, index) in floorList"
                      :value="item"
                      :key="index"
                    >
                      {{ item }}
                    </Option>
                  </Select>
                </div>
                <div class="select-wrap">
                  <Select
                    transfer
                    :word-wrap="true"
                    v-model="status"
                    clearable
                    style="width: 150px; margin-right: 10px"
                    placeholder="状态"
                    @on-change="statusSelectFn"
                    v-if="
                      tableOption.blockType == 'dq' ||
                      tableOption.blockType == 'xfs' ||
                      tableOption.blockType == 'tc' ||
                      tableOption.blockType == 'qt'
                    "
                  >
                    <Option
                      v-for="(item, index) in statusList"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.name }}
                    </Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 巡检 -->
        <div class="common-option" v-show="tableOption.blockType == 'xj'">
          <div class="detail_tit_wrap">
            <span class="block_tit">
              {{ tableOption.title }}
            </span>
            <Button type="primary" @click="hideDetailFn">收起</Button>
          </div>
          <div class="form-wrap">
            <Input
              v-model="inpVal"
              style="width: 150px; margin-right: 10px"
              placeholder="设备名称模糊搜索"
              @on-enter="inputSearch"
              clearable
            ></Input>
          </div>
        </div>
        <!-- 火警列表option， 火警1，火警2 公用 -->
        <div
          class="common-option"
          v-show="
            tableOption.blockType == 'hj' ||
            tableOption.blockType == 'hj1' ||
            tableOption.blockType == 'hj2'
          "
        >
          <div class="detail_tit_wrap">
            <span class="block_tit">
              {{ tableOption.title }}
            </span>
            <Button type="primary" @click="hideDetailFn">收起</Button>
          </div>
          <div class="form-wrap">
            <div class="list-wrap">
              <div class="search-group-wrap">
                <div class="select-wrap">
                  <Select
                    v-model="deviceDetailId"
                    clearable
                    placeholder="设备名称"
                    style="width: 100px; margin-right: 10px"
                    @on-change="xfSelectFn"
                    @on-clear="deviceDetail"
                    remote
                    :remote-method="remoteMethod1"
                    filterable
                  >
                    <Option
                      v-for="item in deviceDetailList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </div>
                <!-- 火警1 火警2 隐藏 -->
                <DatePicker
                  transfer
                  :word-wrap="true"
                  v-if="tableOption.blockType == 'hj'"
                  type="daterange"
                  placeholder="时间筛选"
                  @on-change="timeSearch"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 280px"
                  v-model="xfTime"
                ></DatePicker>
              </div>
            </div>
          </div>
        </div>
        <!-- 视频监控 -->
        <div
          class="common-option"
          v-show="
            tableOption.blockType == 'sp' ||
            tableOption.blockType == 'sp1' ||
            tableOption.blockType == 'sp2'
          "
        >
          <div class="detail_tit_wrap">
            <span class="block_tit">
              {{ tableOption.title }}
            </span>
            <Button type="primary" @click="hideDetailFn">收起</Button>
          </div>
        </div>
        <!-- 值班监控 -->
        <div class="common-option" v-show="tableOption.blockType == 'cg3'">
          <div class="detail_tit_wrap">
            <span class="block_tit">
              {{ tableOption.title }}
            </span>
            <Button type="primary" @click="hideDetailFn">收起</Button>
          </div>
        </div>
        <!-- 报警列表option， 报警1，报警2 公用 -->
        <div
          class="common-option"
          v-show="
            tableOption.blockType == 'bj' ||
            tableOption.blockType == 'bj1' ||
            tableOption.blockType == 'bj2'
          "
        >
          <div class="detail_tit_wrap">
            <span class="block_tit">
              {{ tableOption.title }}
            </span>
            <Button type="primary" @click="hideDetailFn">收起</Button>
          </div>
          <div class="form-wrap">
            <div class="list-wrap">
              <div class="search-group-wrap">
                <!-- 报警1 报警2 隐藏 -->
                <div class="select-wrap">
                  <Select
                    v-model="deviceDetailId"
                    clearable
                    placeholder="设备名称"
                    style="width: 100px; margin-right: 10px"
                    @on-change="xfSelectFn"
                    @on-clear="deviceDetail"
                    remote
                    :remote-method="remoteMethod1"
                    filterable
                  >
                    <Option
                      v-for="item in deviceDetailList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </div>
                <DatePicker
                  transfer
                  :word-wrap="true"
                  v-if="tableOption.blockType == 'bj'"
                  type="daterange"
                  placeholder="时间筛选"
                  @on-change="timeSearch"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 280px; margin-right: 10px"
                  v-model="xfTime"
                ></DatePicker>
                <!-- 报警1隐藏 -->
                <!-- <div class="select-wrap">
                  <Select
                    v-if="tableOption.blockType == 'bj' || tableOption.blockType == 'bj2'"
                    v-model="status"
                    transfer
                    :word-wrap="true"
                    clearable
                    style="width: 150px;margin-right: 10px;"
                    placeholder="处理状态"
                    @on-change="xfSelectFn"
                  >
                    <Option value="1">未处理</Option>
                    <Option value="2">已处理</Option>
                    <Option value="3">处理中</Option>
                  </Select>
                </div> -->
                <div class="select-wrap">
                  <Select
                    transfer
                    :word-wrap="true"
                    v-model="baojing"
                    clearable
                    style="width: 150px; margin-right: 10px"
                    placeholder="报警类型"
                    @on-change="xfSelectFn"
                  >
                    <Option
                      v-for="item in bjTypeList"
                      :value="item.code"
                      :key="item.code"
                    >
                      {{ item.name }}
                    </Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 预警列表 预警1， 预警2 公用 -->
        <div
          class="common-option"
          v-show="
            tableOption.blockType == 'yj' ||
            tableOption.blockType == 'yj1' ||
            tableOption.blockType == 'yj2'
          "
        >
          <div class="detail_tit_wrap">
            <span class="block_tit">
              {{ tableOption.title }}
            </span>
            <Button type="primary" @click="hideDetailFn">收起</Button>
          </div>
          <div class="form-wrap">
            <div class="list-wrap">
              <div class="search-group-wrap">
                <div class="select-wrap">
                  <Select
                    v-model="deviceDetailId"
                    transfer
                    :word-wrap="true"
                    clearable
                    placeholder="设备名称"
                    style="width: 100px; margin-right: 10px"
                    @on-change="xfSelectFn"
                    @on-clear="deviceDetail"
                    remote
                    :remote-method="remoteMethod1"
                    filterable
                  >
                    <Option
                      v-for="item in deviceDetailList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </div>
                <DatePicker
                  transfer
                  :word-wrap="true"
                  v-show="tableOption.blockType == 'yj'"
                  type="daterange"
                  placeholder="时间筛选"
                  @on-change="timeSearch"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 280px; margin-right: 10px"
                  v-model="xfTime"
                ></DatePicker>
                <div class="select-wrap">
                  <Select
                    v-model="baojing"
                    transfer
                    :word-wrap="true"
                    clearable
                    placeholder="预警类型"
                    style="width: 100px"
                    @on-change="xfSelectFn"
                  >
                    <Option
                      v-for="item in yjTypeList"
                      :value="item.code"
                      :key="item.code"
                    >
                      {{ item.name }}
                    </Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 故障列表 故障1， 故障2 公用 -->
        <div
          class="common-option"
          v-show="
            tableOption.blockType == 'gz' ||
            tableOption.blockType == 'gz1' ||
            tableOption.blockType == 'gz2'
          "
        >
          <div class="detail_tit_wrap">
            <span class="block_tit">
              {{ tableOption.title }}
            </span>
            <Button type="primary" @click="hideDetailFn">收起</Button>
          </div>
          <div class="form-wrap">
            <div class="list-wrap">
              <div class="search-group-wrap">
                <div class="select-wrap">
                  <Select
                    v-model="deviceDetailId"
                    transfer
                    :word-wrap="true"
                    clearable
                    style="width: 150px; margin-right: 10px"
                    placeholder="设备名称"
                    @on-change="xfSelectFn"
                    @on-clear="deviceDetail"
                    remote
                    :remote-method="remoteMethod1"
                    filterable
                  >
                    <Option
                      v-for="item in deviceDetailList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </div>
                <!-- 故障1 故障2 隐藏 -->
                <DatePicker
                  transfer
                  :word-wrap="true"
                  v-show="tableOption.blockType == 'gz'"
                  type="daterange"
                  placeholder="时间筛选"
                  @on-change="timeSearch"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 280px; margin-right: 10px"
                  v-model="xfTime"
                ></DatePicker>
                <div class="select-wrap">
                  <Select
                    v-model="guzhang"
                    transfer
                    :word-wrap="true"
                    clearable
                    style="width: 150px; margin-right: 10px"
                    placeholder="故障类型"
                    @on-change="xfSelectFn"
                  >
                    <Option
                      v-for="item in guZList"
                      :value="item.code"
                      :key="item.code"
                    >
                      {{ item.name }}
                    </Option>
                  </Select>
                </div>
                <div class="select-wrap">
                  <Select
                    v-model="eventSource"
                    clearable
                    transfer
                    :word-wrap="true"
                    style="width: 150px; margin-right: 10px"
                    placeholder="事件来源"
                    @on-change="xfSelectFn"
                  >
                    <Option
                      v-for="item in eventSourceArr"
                      :value="item.code"
                      :key="item.code"
                    >
                      {{ item.name }}
                    </Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 人员管理今日巡查巡检 -->
        <div
          class="common-option"
          v-show="
            tableOption.blockType == 'xc' ||
            tableOption.blockType == 'xc1' ||
            tableOption.blockType == 'xc2' ||
            tableOption.blockType == 'xc3'
          "
        >
          <div class="xc-wrap">
            <div class="tit_wrap">
              <p class="sub-tit">
                {{ tableOption.title }}
              </p>
              <div class="checkList positionRL">
                <div class="displayIB" @click="reset()">
                  <a class="colorGreyWeight">
                    <span>全部</span>
                  </a>
                </div>
                <a
                  class="displayIB m-l-20"
                  :class="[checkObj['0'] ? 'colorGreyWeight' : 'colorGrey']"
                  @click="check('0')"
                >
                  <span
                    class="displayIB point"
                    :class="[checkObj['0'] ? 'bgGreyBig' : 'bgGrey']"
                  ></span>
                  <span>未巡检</span>
                </a>
                <a
                  class="displayIB m-l-20 colo"
                  :class="[checkObj['3'] ? 'colorGreyWeight' : 'colorGrey']"
                  @click="check('3')"
                >
                  <span
                    class="displayIB point"
                    :class="[checkObj['3'] ? 'bgRed' : 'bgGrey']"
                  ></span>
                  <span>不合格</span>
                </a>
                <a
                  class="displayIB m-l-20"
                  :class="[checkObj['2'] ? 'colorGreyWeight' : 'colorGrey']"
                  @click="check('2')"
                >
                  <span
                    class="displayIB point"
                    :class="[checkObj['2'] ? 'bgGreenBig' : 'bgGrey']"
                  ></span>
                  <span>合格</span>
                </a>
                <a
                  class="displayIB m-l-20"
                  :class="[checkObj['1'] ? 'colorGreyWeight' : 'colorGrey']"
                  @click="check('1')"
                >
                  <span
                    class="displayIB point"
                    :class="[checkObj['1'] ? 'bgPrimary' : 'bgGrey']"
                  ></span>
                  <span>待巡检</span>
                </a>
              </div>
            </div>
            <ul>
              <li v-for="(item, index) in tableListArr" :key="index">
                <div class="xc-head-option">
                  <div class="info-progress">
                    <span :title="item.planName">
                      {{ item.planName }}
                    </span>
                    <span>
                      {{ timestamp(item.beginTime) }} ～
                      {{ timestamp(item.endTime) }}
                    </span>
                    <Progress
                      :percent="(item.patrolledCount / item.pointCount) * 100"
                    />
                  </div>
                  <div class="info-time">
                    <span :title="item.planPeriodTypeName">
                      周期：{{ item.planPeriodTypeName }}
                    </span>
                    <span :title="item.lstPatrolUserName">
                      负责人：{{ item.lstPatrolUserName }}
                    </span>
                    <span>
                      巡检状态：{{
                        item.state === 0
                          ? "进行中"
                          : item.state === 1
                          ? "巡查完成"
                          : "已超期"
                      }}
                    </span>
                  </div>
                </div>
                <div class="xc-list-block-wrap">
                  <Col
                    span="4"
                    class="m-t-10 colorWhite font14"
                    v-for="items in item.deviceResults"
                    :key="items.deviceId"
                  >
                    <div
                      v-show="checkObj[String(items.patrolState)]"
                      class="blockH60 block"
                      style="overflow: hidden"
                      :class="[
                        items.patrolState == 0
                          ? 'bgGreyBig'
                          : items.patrolState == 3
                          ? 'bgRed'
                          : items.patrolState == 2
                          ? 'bgGreenBig'
                          : items.patrolState == 1
                          ? 'bgPrimary'
                          : '',
                      ]"
                    >
                      <span
                        style="
                          display: block;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          padding: 0 10px;
                        "
                        class="vMiddle"
                        @click="xcDeatil(items.deviceName, items.deviceId)"
                        >{{ items.deviceName }}</span
                      >
                    </div>
                  </Col>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 人员管理隐患 -->
        <div
          class="common-option"
          v-show="
            tableOption.blockType == 'yh' ||
            tableOption.blockType == 'yh1' ||
            tableOption.blockType == 'yh2'
          "
        >
          <div class="detail_tit_wrap">
            <span class="block_tit">
              {{ tableOption.title }}
            </span>
            <Button type="primary" @click="hideDetailFn">收起</Button>
          </div>
          <div class="form-wrap">
            <Dropdown
              trigger="click"
              style="
                padding-left: 10px;
                padding-right: 10px;
                padding-top: 5px;
                cursor: pointer;
              "
              @on-click="changeMenu"
            >
              <span name="deviceName" v-html="this.MenuText">设备名称</span>
              <Icon type="ios-arrow-down"></Icon>
              <DropdownMenu slot="list">
                <DropdownItem name="deviceName">设备名称</DropdownItem>
                <DropdownItem name="content">内容</DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <Input
              class="contentMohu"
              v-if="this.MenuText == '设备名称'"
              v-model="inpVal"
              icon="ios-search"
              @on-click="inputSearch"
              style="width: 150px"
              placeholder="设备名称模糊搜索"
              @on-enter="inputSearch"
              clearable
            ></Input>
            <Input
              class="contentMohu"
              v-else
              v-model="inpCon"
              style="width: 150px; margin-right: 10px"
              placeholder="内容模糊搜索"
              @on-enter="inputSearch"
              clearable
            ></Input>
            <!-- 隐患1 隐患2 隐藏 -->
            <DatePicker
              transfer
              :word-wrap="true"
              v-show="tableOption.blockType == 'yh'"
              @on-change="timeSearch"
              type="daterange"
              placeholder="时间筛选"
              format="yyyy-MM-dd HH:mm"
              split-panels
              style="width: 280px; margin-left: 10px"
            ></DatePicker>
          </div>
        </div>
        <!-- 人员管理查岗 -->
        <div
          class="common-option"
          v-show="
            tableOption.blockType == 'cg' ||
            tableOption.blockType == 'cg1' ||
            tableOption.blockType == 'cg2'
          "
        >
          <div class="detail_tit_wrap">
            <span class="block_tit">
              {{ echartClickTit }}
            </span>
            <Button type="primary" @click="hideDetailFn">收起</Button>
          </div>
          <div class="form-wrap">
            <div class="list-wrap">
              <div class="search-group-wrap">
                <Input
                  v-model="inpVal"
                  icon="ios-search"
                  style="width: 150px; margin-left: 10px"
                  placeholder="名称模糊搜索"
                  @on-enter="inputSearch"
                  @on-click="inputSearch"
                  clearable
                ></Input>
                <div class="select-wrap">
                  <Select
                    v-model="comId"
                    transfer
                    :word-wrap="true"
                    clearable
                    style="width: 150px; margin-left: 10px"
                    placeholder="发起单位"
                    v-show="tableOption.blockType == 'cg2'"
                    @on-change="comSelectFn"
                  >
                    <Option
                      v-for="item in comList"
                      :value="item.orgId"
                      :key="item.orgId"
                    >
                      {{ item.orgName }}
                    </Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 人员管理培训 -->
        <div
          class="common-option"
          v-show="
            tableOption.blockType == 'px' ||
            tableOption.blockType == 'px1' ||
            tableOption.blockType == 'px2' ||
            tableOption.blockType == 'px3'
          "
        >
          <div class="detail_tit_wrap">
            <span class="block_tit">
              {{ echartClickTit }}
            </span>
            <Button type="primary" @click="hideDetailFn">收起</Button>
          </div>
          <div class="form-wrap">
            <Input
              v-model="inpVal"
              icon="ios-search"
              @on-click="inputSearch"
              style="width: 150px; margin-left: 10px"
              placeholder="名称模糊搜索"
              @on-enter="inputSearch"
              clearable
            ></Input>
            <DatePicker
              transfer
              :word-wrap="true"
              @on-change="timeSearch"
              type="daterange"
              placeholder="时间筛选"
              style="width: 150px; margin-left: 10px"
            ></DatePicker>
          </div>
        </div>
      </div>
      <!-- 公用表格 -->
      <div
        class="table-wrap modal-table-wrap block-detail-table"
        style="overflow: inherit"
      >
        <div class="table-head">
          <!-- 消防主机 -->
          <div
            class="common-table-head"
            v-show="tableOption.blockType == 'xfz'"
          >
            <table>
              <tr>
                <th width="5%">序号</th>
                <th width="10%">主机名称</th>
                <th width="10%">品牌</th>
                <th width="20%">型号</th>
                <th width="20%">编号</th>
                <th width="20%">用户信息传输装置</th>
                <!--<th width="10%">-->
                <!--状态-->
                <!--</th>-->
                <th width="10%">操作</th>
              </tr>
            </table>
          </div>
          <div
            class="common-table-head"
            v-show="tableOption.blockType == 'xfz1'"
          >
            <table>
              <tr>
                <th width="5%">序号</th>
                <th width="10%">部件名称</th>
                <th width="10%">部件类型</th>
                <th width="20%">所属建筑</th>
                <th width="20%">所属楼层</th>
                <th width="10%">部件状态</th>
                <th width="10%">操作</th>
              </tr>
            </table>
          </div>
          <div
            class="common-table-head"
            v-show="tableOption.blockType == 'xfz2'"
          >
            <table>
              <tr>
                <th width="10%">序号</th>
                <th width="10%">部件名称</th>
                <th width="10%">部件类型</th>
                <th width="20%">所属建筑</th>
                <th width="20%">所属楼层</th>
                <th width="10%">部件状态</th>
                <th width="10%">操作</th>
              </tr>
            </table>
          </div>
          <div
            class="common-table-head"
            v-show="
              tableOption.blockType == 'dq' ||
              tableOption.blockType == 'dq1' ||
              tableOption.blockType == 'dq2' ||
              tableOption.blockType == 'xfs' ||
              tableOption.blockType == 'xfs1' ||
              tableOption.blockType == 'xfs2' ||
              tableOption.blockType == 'tc' ||
              tableOption.blockType == 'tc1' ||
              tableOption.blockType == 'tc2' ||
              tableOption.blockType == 'zdmh' ||
              tableOption.blockType == 'zdmh1' ||
              tableOption.blockType == 'zdmh2' ||
              tableOption.blockType == 'qt' ||
              tableOption.blockType == 'qt1' ||
              tableOption.blockType == 'qt2'
            "
          >
            <table>
              <tr>
                <th width="10%">序号</th>
                <th width="10%">设施名称</th>
                <th width="10%">设施系统类型</th>
                <th width="20%">所属建筑</th>
                <th width="10%">所属楼层</th>
                <th width="20%">安装位置</th>
                <th width="10%">状态</th>
                <th width="20%">操作</th>
              </tr>
            </table>
          </div>
          <div class="common-table-head" v-show="tableOption.blockType == 'xj'">
            <table>
              <tr>
                <th width="10%">序号</th>
                <th width="30%">卡印刷号</th>
                <th width="20%">设备/重点部位名称</th>
                <th width="40%">安装位置</th>
              </tr>
            </table>
          </div>
          <!-- 火警列表，火警1，火警2公用 -->
          <div
            class="common-table-head"
            v-show="
              tableOption.blockType == 'hj' ||
              tableOption.blockType == 'hj1' ||
              tableOption.blockType == 'hj2'
            "
          >
            <table>
              <tr>
                <th width="10%">序号</th>
                <th width="10%">火警时间</th>
                <th width="20%">设备名称</th>
                <th width="20%">火警内容</th>
                <!-- <th width="20%">
                  安装位置
                </th> -->
                <th width="10%">处理状态</th>
                <th width="10%">操作</th>
              </tr>
            </table>
          </div>
          <!-- 报警公用 -->
          <div
            class="common-table-head"
            v-show="
              tableOption.blockType == 'bj' ||
              tableOption.blockType == 'bj1' ||
              tableOption.blockType == 'bj2'
            "
          >
            <table>
              <tr>
                <th width="10%">序号</th>
                <th width="10%">报警时间</th>
                <th width="10%">设备名称</th>
                <th width="10%">报警类型</th>
                <th width="15%">报警内容</th>
                <!-- <th width="15%">
                  位置
                </th> -->
                <th width="10%">处理状态</th>
                <th width="10%">图片</th>
                <th width="10%">操作</th>
              </tr>
            </table>
          </div>
          <!-- 预警公用 -->
          <div
            class="common-table-head"
            v-show="
              tableOption.blockType == 'yj' ||
              tableOption.blockType == 'yj1' ||
              tableOption.blockType == 'yj2'
            "
          >
            <table>
              <tr>
                <th width="10%">序号</th>
                <th width="10%">预警时间</th>
                <th width="10%">设备名称</th>
                <th width="10%">预警类型</th>
                <th width="15%">预警内容</th>
                <!-- <th width="15%">
                  位置
                </th> -->
                <th width="10%">处理状态</th>
                <th width="10%">图片</th>
                <th width="10%">操作</th>
              </tr>
            </table>
          </div>
          <!-- 故障公用 -->
          <div
            class="common-table-head"
            v-show="
              tableOption.blockType == 'gz' ||
              tableOption.blockType == 'gz1' ||
              tableOption.blockType == 'gz2'
            "
          >
            <table>
              <tr>
                <th width="10%">序号</th>
                <th width="10%">故障时间</th>
                <th width="10%">设备名称</th>
                <th width="10%">故障类型</th>
                <th width="10%">故障内容</th>
                <!-- <th width="10%">
                  位置
                </th> -->
                <th width="10%">处理状态</th>
                <!-- <th width="10%">
                                    事件来源
                                </th>
                                <th width="10%">
                                    图片
                                </th> -->
                <th width="10%">操作</th>
              </tr>
            </table>
          </div>
          <!-- 隐患公用 -->
          <div
            class="common-table-head"
            v-show="
              tableOption.blockType == 'yh' ||
              tableOption.blockType == 'yh1' ||
              tableOption.blockType == 'yh2'
            "
          >
            <table>
              <tr>
                <th width="10%">序号</th>
                <th width="10%">设备名称</th>
                <th width="30%">隐患内容</th>
                <!-- <th width="20%">
                  位置
                </th> -->
                <th width="20%">隐患时间</th>
                <th width="10%">操作</th>
              </tr>
            </table>
          </div>
          <!-- 查岗公用 -->
          <div
            class="common-table-head"
            v-show="
              tableOption.blockType == 'cg' ||
              tableOption.blockType == 'cg1' ||
              tableOption.blockType == 'cg2'
            "
          >
            <table>
              <tr v-if="sponsoredUnit != '离岗'">
                <th width="5%">序号</th>
                <th width="10%">查岗发起人</th>
                <th width="10%" v-if="sponsoredUnit == '被查'">发起单位</th>
                <th width="20%">发起时间</th>
                <th width="20%">结束时间</th>
                <th width="20%">查岗结果</th>
                <th width="15%">图片</th>
              </tr>
              <tr v-else>
                <th width="5%">序号</th>
                <th width="20%">离岗时间</th>
                <th width="20%">设备名称</th>
                <th width="20%">内容</th>
                <!--  <th width="20%">
                                    位置
                                </th>-->
                <th width="15%">图片</th>
              </tr>
            </table>
          </div>
          <!-- 培训演练公用 -->
          <div
            class="common-table-head"
            v-show="
              tableOption.blockType == 'px' ||
              tableOption.blockType == 'px1' ||
              tableOption.blockType == 'px2' ||
              tableOption.blockType == 'px3'
            "
          >
            <table>
              <tr>
                <th width="8%">序号</th>
                <th width="15%">
                  {{ isYl ? "演练标题" : "培训标题" }}
                </th>
                <th width="20%">
                  {{ isYl ? "演练内容" : "培训内容" }}
                </th>
                <th width="15%">发起时间</th>
                <th width="15%">结束时间</th>
                <th width="15%" v-if="isYl">演练要求</th>
                <th width="10%">
                  {{ isYl ? "演练状态" : "培训状态" }}
                </th>
                <th width="15%" v-if="isYl">演练结果</th>
                <th width="10%" v-if="!isYl">参加率</th>
                <th width="10%" v-if="!isYl">合格率</th>
                <th width="5%">操作</th>
              </tr>
            </table>
          </div>
        </div>
        <div class="table-body" style="overflow: inherit" id="modal-table-body">
          <!-- 消防主机 -->
          <div
            class="common-table-head"
            v-show="tableOption.blockType == 'xfz'"
          >
            <table v-if="tableListArr.length">
              <tr v-for="(item, index) in tableListArr" :key="index">
                <td width="5%">
                  <Poptip
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="index + 1"
                  >
                    {{ index + 1 }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.name"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.name"
                  >
                    {{ item.name }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.manufacturerName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.manufacturerName"
                  >
                    {{ item.manufacturerName }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.model"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.model"
                  >
                    {{ item.model }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.sid"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.sid"
                  >
                    {{ item.sid }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.moduleName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.moduleName"
                  >
                    {{ item.moduleName }}
                  </Poptip>
                </td>
                <!--<td width="10%">-->
                <!--状态-->
                <!--</td>-->
                <td width="10%">
                  <Poptip
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    content="事件记录"
                  >
                    <i
                      class="iconfont info-btn"
                      @click="eventStatis(item.id, 'xfz')"
                      >&#xe629;</i
                    >
                  </Poptip>
                </td>
              </tr>
            </table>
          </div>
          <div
            class="common-table-head"
            v-show="tableOption.blockType == 'xfz1'"
          >
            <table v-if="tableListArr.length">
              <tr v-for="(item, index) in tableListArr" :key="index">
                <td width="5%">
                  <Poptip
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="index + 1"
                  >
                    {{ index + 1 }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.name"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.name"
                  >
                    {{ item.name }}
                  </Poptip>
                </td>

                <td width="10%">
                  <Poptip
                    v-if="item.typeName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.typeName"
                  >
                    {{ item.typeName }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.buildingName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.buildingName"
                  >
                    {{ item.buildingName }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.floor"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.floor"
                  >
                    {{ item.floor }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.stateName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.stateName"
                  >
                    {{ item.stateName }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    content="事件记录"
                  >
                    <i
                      class="iconfont info-btn"
                      @click="eventStatis(item.id, 'xfz1')"
                      >&#xe629;</i
                    >
                    <!-- <span
                      class="info-btn"
                      @click="eventStatis(item.id, 'xfz1')"
                    >
                      事件记录
                    </span> -->
                  </Poptip>
                </td>
              </tr>
            </table>
          </div>
          <div
            class="common-table-head"
            v-show="tableOption.blockType == 'xfz2'"
          >
            <table v-if="tableListArr.length">
              <tr v-for="(item, index) in tableListArr" :key="index">
                <td width="10%">
                  <Poptip
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="index + 1"
                  >
                    {{ index + 1 }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.name"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.name"
                  >
                    {{ item.name }}
                  </Poptip>
                </td>

                <td width="10%">
                  <Poptip
                    v-if="item.typeName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.typeName"
                  >
                    {{ item.typeName }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.buildingName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.buildingName"
                  >
                    {{ item.buildingName }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.floor"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.floor"
                  >
                    {{ item.floor }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.stateName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.stateName"
                  >
                    {{ item.stateName }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    content="事件记录"
                  >
                    <i
                      class="iconfont info-btn"
                      @click="eventStatis(item.id, 'xfz2')"
                      >&#xe629;</i
                    >
                    <!-- <span
                      class="info-btn"
                      @click="eventStatis(item.id, 'xfz2')"
                    >
                      事件记录
                    </span> -->
                  </Poptip>
                </td>
              </tr>
            </table>
          </div>
          <!-- 电气 消防水系统 独立式探测器 自动灭火系统 -->
          <div
            class="common-table-head"
            v-show="
              tableOption.blockType == 'dq' ||
              tableOption.blockType == 'dq1' ||
              tableOption.blockType == 'dq2' ||
              tableOption.blockType == 'xfs' ||
              tableOption.blockType == 'xfs1' ||
              tableOption.blockType == 'xfs2' ||
              tableOption.blockType == 'tc' ||
              tableOption.blockType == 'tc1' ||
              tableOption.blockType == 'tc2' ||
              tableOption.blockType == 'qt' ||
              tableOption.blockType == 'qt1' ||
              tableOption.blockType == 'qt2' ||
              tableOption.blockType == 'zdmh' ||
              tableOption.blockType == 'zdmh1' ||
              tableOption.blockType == 'zdmh2'
            "
          >
            <table v-if="tableListArr.length">
              <tr v-for="(item, index) in tableListArr" :key="index">
                <td width="10%">
                  <Poptip
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="index + 1"
                  >
                    {{ index + 1 }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.deviceName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.deviceName"
                  >
                    {{ item.deviceName }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.typeName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.typeName"
                  >
                    {{ item.typeName }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.buildingName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.buildingName"
                  >
                    {{ item.buildingName }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.floor"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.floor"
                  >
                    {{ item.floor }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.position"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.position"
                  >
                    {{ item.position }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.stateName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.stateName"
                  >
                    {{ item.stateName }}
                  </Poptip>
                </td>
                <td width="20%">
                  <div class="option-wrap">
                    <span @click="showDetail(item)">
                      <i class="iconfont">&#xe688;</i>
                    </span>
                    <i
                      class="iconfont info-btn"
                      @click="monitor(item.id, tableOption.blockType, item)"
                      >&#xe602;</i
                    >
                    <i
                      v-if="tableOption.blockType == 'qt'"
                      class="iconfont info-btn"
                      @click="eventStatis(item.id, 'qt', item)"
                      >&#xe629;</i
                    >
                    <i
                      v-if="tableOption.blockType == 'qt1'"
                      class="iconfont info-btn"
                      @click="eventStatis(item.id, 'qt1', item)"
                      >&#xe629;</i
                    >
                    <i
                      v-if="tableOption.blockType == 'qt2'"
                      class="iconfont info-btn"
                      @click="eventStatis(item.id, 'qt2', item)"
                      >&#xe629;</i
                    >
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <!-- 视频列表、值班监控列表 -->
          <div
            class="common-table-head"
            style="height: 100%; display: flex"
            v-show="
              tableOption.blockType == 'sp' ||
              tableOption.blockType == 'sp1' ||
              tableOption.blockType == 'sp2' ||
              tableOption.blockType == 'cg3'
            "
          >
            <div class="page-content" style="flex: 1; flex-shrink: 0">
              <div
                class="video-card-list"
                style="height: 100%"
                v-show="!camera"
              >
                <div
                  class="video-scroll"
                  id="base-layer-block-video"
                  style="height: 100%"
                  v-show="cardList.length"
                >
                  <ul class="video-list video-list-wrap">
                    <li
                      class="list-item-wrap"
                      v-for="(item, index) in cardList"
                      :key="index"
                    >
                      <div
                        class="list-item"
                        @click="targetCamera(item)"
                        @mouseenter="
                          mouseenterVideo('video_' + item.id, item.hlsAddr)
                        "
                        @mouseleave="mouseleaveVideo('video_' + item.id)"
                      >
                        <div class="video-box">
                          <div
                            class="item-video"
                            v-if="currentVideoId == 'video_' + item.id"
                          >
                            <div
                              class="hello-ezuikit-js"
                              v-if="videoType == '1'"
                            >
                              <div
                                id="video-containers"
                                style="width: 100%; height: 100%"
                              ></div>
                            </div>
                            <div v-else-if="videoType == '2'">
                              <hk-video
                                v-if="videoType == '2' && item.hlsAddr"
                                :previewUrl="item.hlsAddr"
                                :VWidth="'600'"
                                :VHeight="'300'"
                                :videoId="videoSid"
                                :channelNum="channelNum"
                                :sid="videoSid"
                              ></hk-video>
                            </div>
                            <div v-else-if="videoType == '4'">
                              <h5-video
                                v-if="videoType == '4' && item.hlsAddr"
                                :previewUrl="item.hlsAddr"
                                :VWidth="'600'"
                                :VHeight="'300'"
                                :videoId="videoSid"
                                :channelNum="channelNum"
                                :sid="videoSid"
                              ></h5-video>
                            </div>
                            <div v-else-if="videoType == '5'">
                              <videoPlay
                                v-if="videoType == '5' && item.hlsAddr"
                                :previewUrl="item.hlsAddr"
                                :videoId="998"
                                :channelNum="channelNum"
                                :videoSid="videoSid"
                                :videoDeviceId="item.id"
                                :height="300"
                                :width="600"
                                :showClose="false"
                              />
                            </div>
                            <video
                              :id="'video_' + item.id"
                              class="video-js vjs-default-skin"
                              muted
                              v-else
                            >
                              <source :src="item.hlsAddr" />
                            </video>
                          </div>
                          <div
                            v-show="currentVideoId != 'video_' + item.id"
                            class="cover"
                          >
                            <img v-if="item.thumbAddr" :src="item.thumbAddr" />
                            <img v-else :src="iconcamera" />
                          </div>
                        </div>
                        <div class="item-title-box">
                          <div class="item-title">
                            <p
                              style="
                                font-weight: bold;
                                font-size: 14px;
                                color: #74d9ff;
                              "
                              :title="item.name"
                            >
                              {{ item.name }}
                            </p>
                            <p :title="item.relateName">
                              {{ item.relateName }}
                            </p>
                          </div>
                          <div class="item-title" style="color: #999">
                            <p :title="item.buildingName">
                              {{ item.buildingName }}
                            </p>
                            <p :title="'楼层：' + item.floor">
                              楼层：{{ item.floor }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  class="center p-t-40"
                  style="color: #08f4f7; font-size: 14px; line-height: 100px"
                  v-show="noData"
                >
                  暂无数据
                </div>
              </div>
              <div
                class="video-card-info"
                style="height: 100%; display: flex; flex-direction: column"
                v-if="camera"
              >
                <!--<div class="info-title" v-show="cardList.length > 1">-->
                <div class="info-title">
                  <div class="title-r">
                    <Button type="primary" @click="cancel">返回列表</Button>
                  </div>
                </div>
                <div
                  class="video-box"
                  style="width: 600px; height: 300px; margin: auto"
                >
                  <videoPlay
                    :previewUrl="modalVideoSrc"
                    :videoId="998"
                    :channelNum="channelNum"
                    :videoSid="videoSid"
                    :videoDeviceId="videoDeviceId"
                    v-if="modalVideoSrc"
                    @hideClose="modalVideoSrc = ''"
                    :height="260"
                    :width="600"
                    :showClose="false"
                  />
                </div>
                <div class="onDutySty" v-if="tableOption.blockType == 'cg3'">
                  <Button class="btnOne" @click="onDuty(1)" type="primary"
                    >在岗</Button
                  >
                  <Button @click="onDuty(0)" type="primary">脱岗</Button>
                </div>
              </div>
            </div>
          </div>
          <div class="common-table-head" v-show="tableOption.blockType == 'xj'">
            <table v-if="tableListArr.length">
              <tr v-for="(item, index) in tableListArr" :key="index">
                <td width="10%">
                  <Poptip
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="index + 1"
                  >
                    {{ index + 1 }}
                  </Poptip>
                </td>
                <td width="30%">
                  <Poptip
                    v-if="item.pressNum"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.pressNum"
                  >
                    {{ item.pressNum }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.deviceName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.deviceName"
                  >
                    {{ item.deviceName }}
                  </Poptip>
                </td>
                <td width="40%">
                  <Poptip
                    v-if="item.installPlace"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.installPlace"
                  >
                    {{ item.installPlace }}
                  </Poptip>
                </td>
              </tr>
            </table>
          </div>
          <!-- 火警列表，火警1，火警2公用 -->
          <div
            class="common-table-body"
            v-show="
              tableOption.blockType == 'hj' ||
              tableOption.blockType == 'hj1' ||
              tableOption.blockType == 'hj2'
            "
          >
            <table v-if="tableListArr.length">
              <tr v-for="(item, index) in tableListArr" :key="index">
                <td width="10%">
                  <Poptip
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="index + 1"
                  >
                    {{ index + 1 }}
                  </Poptip>
                </td>
                <td width="10%" title="">
                  <Poptip
                    v-if="item.ctime"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="timestamp(item.ctime)"
                  >
                    {{ timestamp(item.ctime) }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.deviceName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.deviceName"
                  >
                    {{ item.deviceName }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.content"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.content"
                  >
                    {{ item.content }}
                  </Poptip>
                </td>
                <!-- <td width="20%">
                  <Poptip
                    v-if="item.address"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.address"
                  >
                    {{item.address}}
                  </Poptip>
                </td> -->
                <td width="10%">
                  <Poptip
                    v-if="item.state"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.state"
                  >
                    {{ item.state }}
                  </Poptip>
                </td>
                <td width="10%">
                  <div class="td-option-wrap">
                    <i
                      class="iconfont"
                      :class="{ active: item.cameras }"
                      @click="openHls(item.cameras)"
                      >&#xe7bc;</i
                    >

                    <i
                      class="iconfont"
                      :class="{ active: item.mapPosition }"
                      @click="showLocation(item)"
                    >
                      &#xe618;
                    </i>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <!-- 报警、预警公用 -->
          <div
            class="common-table-body"
            v-show="
              tableOption.blockType == 'bj' ||
              tableOption.blockType == 'bj1' ||
              tableOption.blockType == 'bj2' ||
              tableOption.blockType == 'yj' ||
              tableOption.blockType == 'yj1' ||
              tableOption.blockType == 'yj2'
            "
          >
            <table v-if="tableListArr.length">
              <tr v-for="(item, index) in tableListArr" :key="index">
                <td width="10%">
                  <Poptip
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="index + 1"
                  >
                    {{ index + 1 }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.ctime"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="timestamp(item.ctime)"
                  >
                    {{ timestamp(item.ctime) }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.deviceName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.deviceName"
                  >
                    {{ item.deviceName }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.typeName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.typeName"
                  >
                    {{ item.typeName }}
                  </Poptip>
                </td>
                <td width="15%">
                  <Poptip
                    v-if="item.content"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.content"
                  >
                    {{ item.content }}
                  </Poptip>
                </td>
                <!-- <td width="15%">
                  <Poptip
                    v-if="item.address"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.address"
                  >
                    {{item.address}}
                  </Poptip>
                </td> -->
                <td width="10%">
                  <Poptip
                    v-if="item.state"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.state"
                  >
                    {{ item.state }}
                  </Poptip>
                </td>
                <td width="10%">
                  <i
                    class="iconfont imgView"
                    :class="{ active: !item.imgPath }"
                    @click="showImg(item.imgPath)"
                    >&#xe635;</i
                  >
                </td>
                <td width="10%">
                  <div class="td-option-wrap">
                    <i
                      class="iconfont"
                      :class="{ active: item.cameras }"
                      @click="openHls(item.cameras)"
                      >&#xe7bc;</i
                    >

                    <i
                      class="iconfont"
                      :class="{ active: item.mapPosition }"
                      @click="showLocation(item)"
                    >
                      &#xe618;
                    </i>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <!-- 故障公用 -->
          <div
            class="common-table-body"
            v-show="
              tableOption.blockType == 'gz' ||
              tableOption.blockType == 'gz1' ||
              tableOption.blockType == 'gz2'
            "
          >
            <table v-if="tableListArr.length">
              <tr v-for="(item, index) in tableListArr" :key="index">
                <td width="10%">
                  <Poptip
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="index + 1"
                  >
                    {{ index + 1 }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.ctime"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="timestamp(item.ctime)"
                  >
                    {{ timestamp(item.ctime) }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.deviceName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.deviceName"
                  >
                    {{ item.deviceName }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.typeName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.typeName"
                  >
                    {{ item.typeName }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.content"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.content"
                  >
                    {{ item.content }}
                  </Poptip>
                </td>
                <!-- <td width="10%">
                  <Poptip
                    v-if="item.address"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.address"
                  >
                    {{item.address}}
                  </Poptip>
                </td> -->
                <td width="10%">
                  <Poptip
                    v-if="item.state"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.state"
                  >
                    {{ item.state }}
                  </Poptip>
                </td>
                <!-- <td width="10%" :title="item.source">
                                    {{item.source}}
                                </td>
                                <td width="10%">
                                    <i v-if="item.filePath" class="iconfont imgView" :class="{'active': item.filePath}"
                                       @click="showImg(item.filePath)">&#xe635;</i>
                                </td> -->
                <td width="10%">
                  <div class="td-option-wrap">
                    <i
                      class="iconfont"
                      :class="{ active: item.cameras }"
                      @click="openHls(item.cameras)"
                      >&#xe7bc;</i
                    >

                    <i
                      class="iconfont"
                      :class="{ active: item.mapPosition }"
                      @click="showLocation(item)"
                    >
                      &#xe618;
                    </i>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <!-- 隐患公用 -->
          <div
            class="common-table-body"
            v-show="
              tableOption.blockType == 'yh' ||
              tableOption.blockType == 'yh1' ||
              tableOption.blockType == 'yh2'
            "
          >
            <table v-if="tableListArr.length">
              <tr v-for="(item, index) in tableListArr" :key="index">
                <td width="10%">
                  <Poptip
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="index + 1"
                  >
                    {{ index + 1 }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.deviceName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.deviceName"
                  >
                    {{ item.deviceName }}
                  </Poptip>
                </td>
                <td width="30%">
                  <Poptip
                    v-if="item.content"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.content"
                  >
                    {{ item.content }}
                  </Poptip>
                </td>
                <!-- <td width="20%">
                  <Poptip
                    v-if="item.position"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.address"
                  >
                    {{item.address}}
                  </Poptip>
                </td> -->
                <td width="20%">
                  <Poptip
                    v-if="item.ctime"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="timestamp(item.ctime)"
                  >
                    {{ timestamp(item.ctime) }}
                  </Poptip>
                </td>
                <td width="10%">
                  <div class="td-option-wrap">
                    <i
                      class="iconfont"
                      :class="{ active: item.cameras }"
                      @click="openHls(item.cameras)"
                      >&#xe7bc;</i
                    >

                    <i
                      class="iconfont"
                      :class="{ active: item.mapPosition }"
                      @click="showLocation(item)"
                    >
                      &#xe618;
                    </i>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <!-- 查岗公用 -->
          <div
            class="common-table-body"
            v-show="
              tableOption.blockType == 'cg' ||
              tableOption.blockType == 'cg1' ||
              tableOption.blockType == 'cg2'
            "
          >
            <table v-if="sponsoredUnit != '离岗' && tableListArr.length">
              <tr v-for="(item, index) in tableListArr" :key="index">
                <td width="5%">
                  <Poptip
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="index + 1"
                  >
                    {{ index + 1 }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.userName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.userName"
                  >
                    {{ item.userName }}
                  </Poptip>
                </td>
                <td width="10%" v-if="sponsoredUnit == '被查'">
                  <Poptip
                    v-if="item.orgName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.orgName"
                  >
                    {{ item.orgName }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.startTime"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="timestamp(item.startTime)"
                  >
                    {{ timestamp(item.startTime) }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.endTime"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="timestamp(item.endTime)"
                  >
                    {{ timestamp(item.endTime) }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    trigger="hover"
                    transfer
                    v-if="item.result"
                    :word-wrap="true"
                    :content="item.result == 1 ? '合格' : '不合格'"
                  >
                    {{ item.result == 1 ? "合格" : "不合格" }}
                  </Poptip>
                  <span v-else>~</span>
                </td>
                <td width="15%">
                  <i
                    v-if="item.filePath"
                    class="iconfont imgView"
                    :class="{ active: item.filePath }"
                    @click="showImg(item.filePath)"
                    >&#xe635;</i
                  >
                  <Icon
                    type="ios-image"
                    style="font-size: 16px; cursor: not-allowed; opacity: 0.6"
                    v-else
                  />
                </td>
              </tr>
            </table>
            <table v-else>
              <tr v-for="(item, index) in tableListArr" :key="index">
                <td width="5%">
                  <Poptip
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="index + 1"
                  >
                    {{ index + 1 }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.ctime"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="timestamp(item.ctime)"
                  >
                    {{ timestamp(item.ctime) }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.deviceName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.deviceName"
                  >
                    {{ item.deviceName }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.content"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.content"
                  >
                    {{ item.content }}
                  </Poptip>
                </td>
                <!--      <td width="20%" >

                                    <Poptip
                                        trigger="hover"
                                        transfer :word-wrap="true"
                                        :content="item.position"
                                    >
                                        {{item.position}}
                                    </Poptip>
                                </td>-->
                <td width="15%">
                  <i
                    v-if="item.filePath"
                    class="iconfont imgView"
                    :class="{ active: item.filePath }"
                    @click="showImg(item.filePath)"
                    >&#xe635;</i
                  >
                  <Icon
                    type="ios-image"
                    style="font-size: 16px; cursor: not-allowed; opacity: 0.6"
                    v-else
                  />
                </td>
              </tr>
            </table>
          </div>
          <!-- 培训演练公用 -->
          <div
            class="common-table-body"
            v-show="
              tableOption.blockType == 'px' ||
              tableOption.blockType == 'px1' ||
              tableOption.blockType == 'px2' ||
              tableOption.blockType == 'px3'
            "
          >
            <table v-if="tableListArr.length">
              <tr v-for="(item, index) in tableListArr" :key="index">
                <td width="8%">
                  <Poptip
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="index + 1"
                  >
                    {{ index + 1 }}
                  </Poptip>
                </td>
                <td width="15%">
                  <Poptip
                    v-if="item.title"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.title"
                  >
                    {{ item.title }}
                  </Poptip>
                </td>
                <td width="20%">
                  <Poptip
                    v-if="item.content"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.content"
                  >
                    {{ item.content }}
                  </Poptip>
                </td>
                <td width="15%">
                  <Poptip
                    v-if="item.beginTime"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="timestamp(item.beginTime)"
                  >
                    {{ timestamp(item.beginTime) }}
                  </Poptip>
                </td>
                <td width="15%">
                  <Poptip
                    v-if="item.endTime"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="timestamp(item.endTime)"
                  >
                    {{ timestamp(item.endTime) }}
                  </Poptip>
                </td>
                <td width="15%" v-if="isYl">
                  <Poptip
                    v-if="item.requirements"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.requirements"
                  >
                    {{ item.requirements }}
                  </Poptip>
                </td>
                <td width="10%">
                  <Poptip
                    v-if="item.taskStateName"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.taskStateName"
                  >
                    {{ item.taskStateName }}
                  </Poptip>
                </td>
                <td width="15%" v-if="isYl">
                  <Poptip
                    trigger="hover"
                    transfer
                    v-show="item.result"
                    :word-wrap="true"
                    :content="item.result == 0 ? '不合格' : '合格'"
                  >
                    {{ item.result == 0 ? "不合格" : "合格" }}
                  </Poptip>
                  <span v-show="!item.result">~</span>
                </td>
                <td width="10%" v-if="!isYl">
                  <Poptip
                    v-if="item.joiningRate"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.joiningRate"
                  >
                    {{ item.joiningRate }}
                  </Poptip>
                </td>
                <td width="10%" v-if="!isYl">
                  <Poptip
                    v-if="item.percentRate"
                    trigger="hover"
                    transfer
                    :word-wrap="true"
                    :content="item.percentRate"
                  >
                    {{ item.percentRate }}
                  </Poptip>
                </td>
                <td width="5%">
                  <Icon
                    size="20"
                    @click="pxDetail(item.taskId)"
                    type="ios-information-circle-outline"
                    style="cursor: pointer"
                  />
                </td>
              </tr>
            </table>
          </div>
          <!-- <div class="common-table-body nodata" v-show="noData">暂无数据！</div> -->
          <div
            class="more-btn-wrap"
            v-show="tableListArr.length && tableListArr.length < totalCount"
            @click="getMoreData"
          >
            <div class="btn">
              <i class="iconfont">&#xe60e;</i>
              <span
                >加载更多（剩余{{ totalCount - tableListArr.length }}条）</span
              >
            </div>
          </div>
        </div>
        <div class="loading" v-if="loading_status">
          <!-- 加载动画 -->
          <div class="loading_box" v-show="!tableListArr.length">
            <img :src="tableLoad" />
          </div>
          <div class="more_data_box" v-show="tableListArr.length">
            <img :src="tableMore" />
          </div>
        </div>
      </div>
    </div>
    <Modal
      v-model="modalShow"
      :closable="true"
      width="800"
      class="baseInfo-modal"
      :footer-hide="true"
      @on-visible-change="modalChangeg"
    >
      <div v-show="!showVideo" style="min-height: 300px">
        <img class="modalImg" :src="modalImgSrc" alt="" v-show="modalImgSrc" />
      </div>

      <div style="width: 700px; margin: auto" v-if="showVideo">
        <div class="video-title">
          <div>{{ videoName }}</div>
          <div class="video-btn">
            <img
              v-if="videoIndex > 0"
              style="cursor: pointer"
              @click="videoClick('prev')"
              src="@/assets/images/videoControl/zuo.png"
              alt=""
            />
            <img v-else src="@/assets/images/videoControl/zuo1.png" alt="" />
            <img
              v-if="videoIndex + 1 < videoTotal"
              style="margin-left: 15px; cursor: pointer"
              src="@/assets/images/videoControl/you.png"
              @click="videoClick('next')"
              alt=""
            />
            <img
              v-else
              style="margin-left: 15px"
              src="@/assets/images/videoControl/you1.png"
              alt=""
            />
          </div>
        </div>
        <videoPlay
          :previewUrl="modalVideoSrc"
          :videoId="997"
          :channelNum="channelNum"
          :videoSid="videoSid"
          :videoDeviceId="videoDeviceId"
          v-if="showVideo"
          @hideClose="modalVideoSrc = ''"
          :height="350"
          :width="700"
          :showClose="false"
        />
        <div v-else style="height: 350px"></div>
      </div>
    </Modal>
    <modal
      :optionBtnIndex="optionBtnIndex"
      @modalClose="modalClose"
      v-if="optionBtnIndex"
      :taskId="taskId"
      :deviceId="deviceId"
      :deviceName="deviceName"
    ></modal>
  </div>
</template>
<script>
// 随机字符串
import { getTime, returnDay, timestampToTime } from "@/assets/js/index";
// 加密
import EZUIKit from "ezuikit-js";
import videoPlay from "./videoPlay/videoPlay.vue";
import hkVideo from "./videoPlay/hkVideo/hkVideo";
import h5Video from "./videoPlay/h5Video/h5Video";
import modal from "./base-layer-modal.vue";
import iconcamera from "@/assets/img/iconcamera.png";
import { contBlockUrl, buildings } from "@/assets/js/url.js";
import videojs from "video.js";
import { getDate } from "@/assets/js/tools";

import tableLoad from "@/assets/img/animation.gif";
import tableMore from "@/assets/img/animation.gif";
import { setTimeout } from "timers";

export default {
  name: "",
  data: () => ({
    videoDeviceId: "",
    modalVideoSrc: "",
    channelNum: "",
    videoSid: "",
    showVideo: false,
    videoName: "",
    videoTotal: "",
    videoIndex: 0,
    camerasList: [],
    noData: false, //无数据
    loading_status: false,
    tableLoad,
    tableMore,
    tableInitStatus: false,
    MenuText: "设备名称",
    iconcamera,
    currentVideoId: "", // 当前鼠标移入的id
    videoPlayerList: {},
    camera: false,
    videoArr: [],
    player: null,
    hostId: "",
    hostList: [],
    comList: [],
    comId: "",
    xfTime: null,
    optionBtnIndex: "",
    echartClickName: "",
    isYl: false,
    sponsoredUnit: "",
    echartShow: false,
    modalShow: false,
    modalImgSrc: "",
    loginData: "",
    hashValue: "",
    inpVal: "",
    inpCon: "",
    cameraModel: {},
    buildingId: null,
    floor: null,
    cityList: [
      {
        value: "New York",
        label: "New York",
      },
      {
        value: "London",
        label: "London",
      },
    ],
    buildList: [],
    floorList: [],
    statusList: [],
    bjTypeList: [],
    yjTypeList: [],
    guZList: [],
    eventSource: "",
    eventSourceArr: [
      {
        code: 1,
        name: "部件",
      },
      {
        code: 2,
        name: "巡检",
      },
      {
        code: 3,
        name: "消防主机",
      },
      {
        code: 4,
        name: "用户传输装置",
      },
      {
        code: 5,
        name: "摄像头",
      },
      {
        code: 6,
        name: "消防主机下挂装置[带点表]",
      },
      {
        code: 7,
        name: "消防主机下挂装置[无点表]打印口",
      },
    ],
    beginTime: null,
    endTime: null,
    model1: "",
    baojing: null,
    guzhang: null,
    videoType: "1",
    status: null,
    tableOption: {
      blockType: "",
      title: "",
      dateType: "",
    },
    echartClickTit: "",
    tableListArr: [],
    echartDom: null,
    currentPage: 1,
    totalCount: 0,
    checkObj: {
      0: true,
      1: true,
      2: true,
      3: true,
    },
    taskId: "",
    deviceId: "",
    deviceName: "",
    accessToken: "",
    startTime: "",
    cameraCode: "",
    checkedOrgId: "",
    deviceDetailList: [],
    deviceDetailId: null, //新加设备列表名称
    timer: null, //延时器
  }),
  props: ["blockObj"],
  watch: {
    blockObj: {
      handler(newVal, oldVal) {
        if (newVal.blockType) {
          this.tableOption.blockType = newVal.blockType;
          this.tableOption.title = newVal.title;
          this.tableOption.dateType = newVal.dateType;
          this.beginTime = "";
          this.endTime = "";
          this.inpVal = "";
          this.inpCon = "";
          (this.MenuText = "设备名称"), (this.currentPage = 1);
          this.totalCount = 0;
          this.tableListArr = [];
          this.buildList = [];
          this.floorList = [];
          this.statusList = [];
          this.buildingId = null;
          this.floor = null;
          this.status = null;
          this.xfTime = null;
          this.comId = "";
          this.cardList = [];
          this.tableInitStatus = false;
          this.echartClickName = "";
          this.echartClickTit = "";
          this.checkObj = {
            0: true,
            1: true,
            2: true,
            3: true,
          };
          this.noData = false; //无数据
          this.loading_status = false;
          if (this.echartDom) {
            this.echartDom.clear();
          }
          this.echartShowFn();

          $JQ("#modal-table-body").mCustomScrollbar("update");
          $JQ("#modal-wrap").mCustomScrollbar("update");
          this.$nextTick(() => {
            this.getData();
            this.getSearchCondition(); //搜索条件
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  components: {
    modal,
    videoPlay,
    hkVideo,
    h5Video,
  },
  created() {},
  mounted() {
    this.startTime = getDate(new Date().getTime(), "year");
    this.hashValue = window.localStorage.getItem("hashValue");
    this.loginData = JSON.parse(window.localStorage.getItem("loginData"));
    this.getToken();
  },
  updated() {
    this.$nextTick(() => {
      if (this.tableInitStatus) {
        // 防抖
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          $JQ("#modal-table-body").mCustomScrollbar("update");
        }, 300);
      }
    });
  },
  computed: {},
  methods: {
    remoteMethod1(query) {
      this.deviceDetail(query);
    },
    hideDetailFn() {
      //收起下拉框
      this.$emit("hideDetail", {
        time: new Date(),
      });
    },
    check(type) {
      this.checkObj[type] = !this.checkObj[type];
    },
    reset() {
      for (let i in this.checkObj) {
        this.checkObj[i] = true;
      }
    },
    deviceDetail(name) {
      let _this = this;
      var orgId = this.$store.state.baseInfoLayer.baseInfoId;
      let url = contBlockUrl.dwDeviceList;
      var data = {
        type: "get",
        url: url,
        obj: {
          currentPage: 1,
          pageSize: 1000,
          orgId: orgId,
          name: name ? name : null,
        },
      };

      _this.$Axios(data).then((res) => {
        //console.log(res);
        if (res.data.success) {
          this.deviceDetailList = res.data.data;
        }
      });
    },
    changeMenu(name) {
      if (name == "deviceName") {
        this.MenuText = "设备名称";
        this.inpCon = null;
      } else if (name == "content") {
        this.MenuText = "内容";
        this.inpVal = null;
      }
    },
    modalClose(res) {
      this.optionBtnIndex = "";
    },
    getToken() {
      var data = {
        type: "get",
        url: `/mcbw/cameras/token`,
        obj: {},
      };
      this.$Axios(data).then((res) => {
        if (res.data.success) {
          this.accessToken = res.data.data;
        }
      });
    },
    mouseenterVideo(id, url) {
      console.log(id, url);
      this.currentVideoId = id;
      if(url && url.includes("mp4")) {
        this.videoType = "5";
      } else if (url && url.includes("ezopen")) {
        this.videoType = "1";
        this.$nextTick(() => {
          this.player = new EZUIKit.EZUIKitPlayer({
            autoplay: true,
            id: "video-containers",
            accessToken: this.accessToken,
            url,
            template: "simple", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
            // 视频上方头部控件
            //header: ["capturePicture", "save", "zoom"], // 如果templete参数不为simple,该字段将被覆盖
            //plugin: ['talk'],                       // 加载插件，talk-对讲
            // 视频下方底部控件
            // footer: ["talk", "broadcast", "hd", "fullScreen"], // 如果template参数不为simple,该字段将被覆盖
            // audio: 1, // 是否默认开启声音 0 - 关闭 1 - 开启
            // openSoundCallBack: data => console.log("开启声音回调", data),
            // closeSoundCallBack: data => console.log("关闭声音回调", data),
            // startSaveCallBack: data => console.log("开始录像回调", data),
            // stopSaveCallBack: data => console.log("录像回调", data),
            // capturePictureCallBack: data => console.log("截图成功回调", data),
            // fullScreenCallBack: data => console.log("全屏回调", data),
            // getOSDTimeCallBack: data => console.log("获取OSDTime回调", data),
            width: 387,
            height: 232,
          });
        });
      } else if (url && url.includes("rtsp://")) {
        this.videoType = "2";
      } else if (url.includes("ws://") || url.includes("wss://")) {
        this.videoType = "4";
      } else if (url && url.includes("http")) {
        this.videoType = "3";
        this.$nextTick(() => {
          let parentNode = document.getElementById(id).parentNode;
          let width = parentNode.offsetWidth;
          let height = parentNode.offsetHeight;
          if (!this.videoPlayerList.hasOwnProperty(id)) {
            this.videoPlayerList[id] = videojs(
              id,
              {
                src: url,
                muted: true,
                autoplay: true,
                controls: false,
                height: height,
                width: width,
              },
              function () {
                videojs.log("播放器已经准备好了!");
              }
            );
          } else {
            this.videoPlayerList[id].play();
          }
        });
      }
    },
    mouseleaveVideo(id) {
      if (this.videoPlayerList.hasOwnProperty(id)) {
        this.videoPlayerList[id].dispose(); //销毁
        delete this.videoPlayerList[id];
      }
      this.currentVideoId = "";
    },
    targetCamera(list) {
      if (list.hlsAddr) {
        this.videoDeviceId = list.id;
        this.modalVideoSrc = list.hlsAddr;
        this.channelNum = list.channelNum;
        this.videoSid = list.num;
      } else {
        this.modalVideoSrc = "http://cehsi";
      }
      this.cameraCode = list.code;
      this.checkedOrgId = list.orgId;
      this.camera = true;

      this.cameraModel = list;
      this.cameraModel._name = list.name;
      this.mouseleaveVideo(list.id);
      // $('.video-scroll').mCustomScrollbar('destroy');
      // this.videoArr.push(1);
      // this.$nextTick(() => {
      //     this.initVideoInside(list.hlsAddr);
      // })
    },
    initVideoInside(url) {
      let parentNode = document.getElementById("myPlayer").parentNode;
      let width = parentNode.offsetWidth;
      let height = parentNode.offsetHeight;
      if (this.player) {
        this.player.src(url);
        this.player.play();
        return;
      }
      this.player = videojs(
        "myPlayer",
        {
          src: url,
          autoplay: true,
          height: height,
          width: width,
        },
        function () {
          videojs.log("111播放器已经准备好了!");
          this.play();
        }
      );
    },
    cancel() {
      this.camera = false;
      this.modalVideoSrc = "";
      // this.videoArr.pop();
      // this.$nextTick(()=>{
      //     this.player.dispose();  //销毁
      //     this.player = null;
      //     $('.video-scroll').mCustomScrollbar();
      // });
    },
    modalChangeg(status) {
      if (!status) {
        this.modalImgSrc = "";
        this.modalVideoSrc = "";
        this.videoIndex = 0;
        // this.$nextTick(()=>{
        //     this.videoDispose();
        // });
      }
    },
    initVideo(url) {
      if (this.player) {
        this.player.src(url);
        this.player.play();
        return;
      }
      this.player = videojs(
        "xfVideo",
        {
          src: url,
          autoplay: true,
          width: 768,
          height: 500,
        },
        function () {
          videojs.log("播放器已经准备好了!");
        }
      );
    },
    videoDispose(id) {
      if (this.player) {
        this.player.dispose();
        this.player = null;
        this.videoArr.pop();
      }
    },
    openHls(cameras) {
      console.log(cameras);
      if (cameras && cameras.length > 0) {
        this.videoTotal = cameras.length;
        this.camerasList = cameras;
        this.videoDeviceId = this.camerasList[this.videoIndex].id;
        this.modalVideoSrc = this.camerasList[this.videoIndex].hlsAddr;
        this.videoName = this.camerasList[this.videoIndex].name;
        this.channelNum = this.camerasList[this.videoIndex].channelNum;
        this.videoSid = this.camerasList[this.videoIndex].num;
        this.modalShow = true;
        this.showVideo = true;
      }
    },
    videoClick(type) {
      this.showVideo = false;
      if (type == "next") {
        this.videoIndex++;
      } else {
        this.videoIndex--;
      }
      this.videoDeviceId = this.camerasList[this.videoIndex].id;
      this.modalVideoSrc = this.camerasList[this.videoIndex].hlsAddr;
      this.channelNum = this.camerasList[this.videoIndex].channelNum;
      this.videoSid = this.camerasList[this.videoIndex].num;
      this.videoName = this.camerasList[this.videoIndex].name;
      setTimeout(() => {
        this.showVideo = true;
      }, 300);
    },
    hlsCancel() {
      // 关闭视频弹框
      // this.player.pause()
      this.modalShow = false;
      this.videoIndex = 0;
      this.camerasList = [];
      this.videoTotal = "";
      this.modalVideoSrc = "";
      this.videoName = "";
    },
    showLocation(item) {
      //定位
      this.optionBtnIndex = "";
      this.$store.commit("eventStatis", {
        status: false,
        id: "",
        type: "",
      });
      this.$store.commit("showDetail", {
        status: false,
        item: {},
      });
      this.$store.commit("monitor", {
        status: false,
        id: "",
        type: "",
        item: {},
      });
      this.$store.commit("showMap", {
        status: false,
        position: null,
      });
      this.$store.commit("showCrtMap", {
        status: true,
        item: item,
      });
    },
    showDetail(item) {
      //详情
      console.log(item);
      this.optionBtnIndex = "";
      this.$store.commit("eventStatis", {
        status: false,
        id: "",
        type: "",
      });
      this.$store.commit("showMap", {
        status: false,
        position: null,
      });
      this.$store.commit("showCrtMap", {
        status: false,
        item: {},
      });
      this.$store.commit("monitor", {
        status: false,
        id: "",
        type: "",
        item: {},
      });
      this.$store.commit("showDetail", {
        status: true,
        item: item,
      });
    },
    monitor(id, type, item) {
      //console.log(id,type,item)
      //实时监测
      this.optionBtnIndex = "";
      this.$store.commit("eventStatis", {
        status: false,
        id: "",
        type: "",
      });
      this.$store.commit("showDetail", {
        status: false,
        item: {},
      });
      this.$store.commit("showMap", {
        status: false,
        position: null,
      });
      this.$store.commit("showCrtMap", {
        status: false,
        item: {},
      });
      this.$store.commit("monitor", {
        status: true,
        id: id,
        type: type,
        item: item,
      });
    },
    eventStatis(id, type, item) {
      //事件统计
      console.log(item);
      this.optionBtnIndex = "";
      this.$store.commit("showDetail", {
        status: false,
        item: {},
      });
      this.$store.commit("showMap", {
        status: false,
        position: null,
      });
      this.$store.commit("showCrtMap", {
        status: false,
        item: {},
      });
      this.$store.commit("monitor", {
        status: false,
        id: "",
        type: "",
        item: {},
      });
      this.$store.commit("eventStatis", {
        status: true,
        id: id,
        type: type,
        item: item,
      });
    },
    echartShowFn() {
      if (
        this.tableOption.blockType == "xfz1" ||
        this.tableOption.blockType == "dq1" ||
        this.tableOption.blockType == "qt1" ||
        this.tableOption.blockType == "xfs1" ||
        this.tableOption.blockType == "tc1" ||
        this.tableOption.blockType == "kk1" ||
        this.tableOption.blockType == "cg" ||
        this.tableOption.blockType == "cg1" ||
        this.tableOption.blockType == "cg2" ||
        this.tableOption.blockType == "px" ||
        this.tableOption.blockType == "px1" ||
        this.tableOption.blockType == "px2" ||
        this.tableOption.blockType == "px3"
      ) {
        this.echartShow = true;
      } else {
        this.echartShow = false;
      }
    },
    returnTimestamp(time) {
      var date = new Date(time);
      return date.getTime();
    },
    timestamp(time) {
      return timestampToTime(time);
    },
    inputSearch() {
      (this.currentPage = 1), (this.tableListArr = []);
      console.log(this.tableOption.blockType);
      if (
        this.tableOption.blockType == "cg1" ||
        this.tableOption.blockType == "cg2" ||
        this.tableOption.blockType == "px" ||
        this.tableOption.blockType == "px1" ||
        this.tableOption.blockType == "px2" ||
        this.tableOption.blockType == "px3"
      ) {
        //直接请求列表
        this.echartClick(this.echartClickName);
        return;
      }
      this.getData();
    },
    timeSearch(res) {
      this.beginTime = res[0];
      this.endTime = res[1];
      (this.currentPage = 1), (this.tableListArr = []);
      this.getData();
    },
    getMoreData() {
      this.currentPage += 1;
      this.getData();
    },
    hostSelectFn() {
      //主机下拉框事件
      (this.currentPage = 1), (this.tableListArr = []);
      this.getData();
    },
    xfSelectFn() {
      //消防运行情况下拉框事件
      (this.currentPage = 1), (this.tableListArr = []);
      this.getData();
    },
    comSelectFn() {
      (this.currentPage = 1), (this.tableListArr = []);
      this.getData();
    },
    buildSelectFn(res) {
      //所属建筑下拉事件
      (this.currentPage = 1), (this.tableListArr = []);
      console.log(res == undefined);
      if (res == undefined) {
        this.buildingId = null;
        this.floor = null;
        this.floorList = [];
      }
      this.getData();
      for (let i = 0; i < this.buildList.length; i++) {
        if (this.buildList[i].id == res) {
          this.getBuildFloor(this.buildList[i].id);
          return;
        }
      }
    },
    floorSelectFn(res) {
      //楼层号下拉事件
      (this.currentPage = 1), (this.tableListArr = []);
      if (res == undefined) {
        this.floor = null;
        // return;
      }
      this.getData();
    },
    statusSelectFn(res) {
      (this.currentPage = 1), (this.tableListArr = []);
      if (res == undefined) {
        this.status = null;
        // return;
      }
      this.getData();
    },
    getHostList() {
      let _this = this;
      let url = contBlockUrl.hostList;
      var data = {
        type: "get",
        url: url,
        obj: {
          orgId: _this.$store.state.baseInfoLayer.baseInfoId,
        },
      };

      _this.$Axios(data).then((res) => {
        // console.log(res);
        console.log("主机列表");

        if (res.data.success) {
          this.hostList = res.data.data;
        }
      });
    },
    getBuildList() {
      //所属建筑列表
      let _this = this;
      let url = contBlockUrl.buildList;
      var data = {
        type: "get",
        url: url,
        obj: {
          orgId: _this.$store.state.baseInfoLayer.baseInfoId,
        },
      };

      _this.$Axios(data).then((res) => {
        // console.log(res);
        console.log("搜索建筑列表");

        if (res.data.success) {
          this.buildList = res.data.data;
        }
      });
    },
    getBuildFloor(buildId = "24221") {
      //楼层号
      let _this = this;
      let url = contBlockUrl.buildFloor + buildId;
      var data = {
        type: "get",
        url: url,
        obj: {
          orgId: _this.$store.state.baseInfoLayer.baseInfoId,
        },
      };

      _this.$Axios(data).then((res) => {
        // console.log(res);
        console.log("搜索楼层列表");

        if (res.data.success) {
          this.floorList = res.data.data.split(",");
        }
      });
    },
    getBuildStatus() {
      //状态
      let _this = this;
      let url = contBlockUrl.deviceStatus;
      var data = {
        type: "get",
        url: url,
        obj: {
          orgId: _this.$store.state.baseInfoLayer.baseInfoId,
        },
      };

      _this.$Axios(data).then((res) => {
        // console.log(res);
        console.log("装置状态列表");

        if (res.data.success) {
          this.statusList = res.data.data;
        }
      });
    },
    getComList() {
      //发起单位列表
      let _this = this;
      let url = contBlockUrl.companyList;
      var data = {
        type: "get",
        url: url,
        obj: {
          checkedOrgId: _this.$store.state.baseInfoLayer.baseInfoId,
          result: null,
          dateType: _this.tableOption.dateType,
        },
      };

      _this.$Axios(data).then((res) => {
        // console.log(res);
        console.log("发起单位列表");

        if (res.data.success) {
          this.comList = res.data.data;
        }
      });
    },
    getSearchCondition() {
      //获取搜索下拉框数据
      if (
        this.tableOption.blockType == "hj" ||
        this.tableOption.blockType == "hj1" ||
        this.tableOption.blockType == "hj2" ||
        this.tableOption.blockType == "bj" ||
        this.tableOption.blockType == "bj1" ||
        this.tableOption.blockType == "bj2" ||
        this.tableOption.blockType == "yj" ||
        this.tableOption.blockType == "yj1" ||
        this.tableOption.blockType == "yj2" ||
        this.tableOption.blockType == "gz" ||
        this.tableOption.blockType == "gz1" ||
        this.tableOption.blockType == "gz2"
      ) {
        this.deviceDetail(); //新增设备下拉框
      } else if (this.tableOption.blockType == "xfz1") {
        //
        this.getBuildList();
        //获取主机列表
        this.getHostList();
      } else if (
        this.tableOption.blockType == "xfz2" ||
        this.tableOption.blockType == "dq1" ||
        this.tableOption.blockType == "dq2" ||
        this.tableOption.blockType == "qt2" ||
        this.tableOption.blockType == "xfs1" ||
        this.tableOption.blockType == "xfs2" ||
        this.tableOption.blockType == "tc1" ||
        this.tableOption.blockType == "kk1" ||
        this.tableOption.blockType == "zdmh1" ||
        this.tableOption.blockType == "zdmh2" ||
        this.tableOption.blockType == "zdmh"
      ) {
        this.getBuildList();
      } else if (this.tableOption.blockType == "qt1") {
        this.getBuildList();
        this.getBuildStatus();
      } else if (
        this.tableOption.blockType == "dq" ||
        this.tableOption.blockType == "qt" ||
        this.tableOption.blockType == "xfs" ||
        this.tableOption.blockType == "tc" ||
        this.tableOption.blockType == "tc2" ||
        this.tableOption.blockType == "kk" ||
        this.tableOption.blockType == "kk2"
      ) {
        this.getBuildList();
        this.getBuildStatus();
      } else if (this.tableOption.blockType == "bj") {
        this.getTypeL();
      } else if (this.tableOption.blockType == "yj") {
        this.getyjTypeL();
      } else if (this.tableOption.blockType == "gz") {
        this.getGzTypeL();
      } else if (this.tableOption.blockType == "cg2") {
        this.getComList();
      }
      this.getTypeL();
      this.getyjTypeL();
      this.getGzTypeL();
      this.deviceDetail();
    },
    getData() {
      //获取数据
      // console.log(JSON.parse(window.localStorage.getItem('loginData')));
      this.loading_status = true;
      this.noData = false;
      let _this = this;
      var data = {
        type: "get",
        url: "",
        obj: {},
      };
      console.log(this.tableOption.blockType);
      if (
        this.tableOption.blockType == "hj" ||
        this.tableOption.blockType == "hj1" ||
        this.tableOption.blockType == "hj2"
      ) {
        //火警
        data.url = contBlockUrl.hjList;
        data.obj = {
          orgId: this.$store.state.baseInfoLayer.baseInfoId,
          sources: "3,6,7",
          pageSize: 10,
          currentPage: this.currentPage,
          beginTime: this.beginTime ? this.beginTime : null,
          endTime: this.endTime ? this.endTime : null,
          state: null,
          type: null,
          /*  deviceName: this.inpVal ? this.inpVal : null,
                        content: this.inpCon ? this.inpCon : null,*/
          deviceId: this.deviceDetailId,
          states: "0,1",
        };

        if (this.tableOption.blockType == "hj1") {
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            sources: "3,6,7",
            pageSize: 10,
            currentPage: this.currentPage,
            beginTime: this.beginTime ? this.beginTime : null,
            endTime: this.endTime ? this.endTime : null,
            state: 2,
            type: null,
            /*  deviceName: this.inpVal ? this.inpVal : null,
                            content: this.inpCon ? this.inpCon : null,*/
            deviceId: this.deviceDetailId,
            dateType: this.tableOption.dateType,
          };
        } else if (this.tableOption.blockType == "hj2") {
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            sources: "3,6,7",
            pageSize: 10,
            currentPage: this.currentPage,
            beginTime: this.beginTime ? this.beginTime : null,
            endTime: this.endTime ? this.endTime : null,
            state: null,
            type: null,
            /*   deviceName: this.inpVal ? this.inpVal : null,
                            content: this.inpCon ? this.inpCon : null,*/
            deviceId: this.deviceDetailId,
            dateType: this.tableOption.dateType,
          };
        }
      } else if (
        this.tableOption.blockType == "bj" ||
        this.tableOption.blockType == "bj1" ||
        this.tableOption.blockType == "bj2"
      ) {
        //报警
        data.url = contBlockUrl.bjList;
        data.obj = {
          orgId: this.$store.state.baseInfoLayer.baseInfoId,
          pageSize: 10,
          currentPage: this.currentPage,
          beginTime: this.beginTime ? this.beginTime : null,
          endTime: this.endTime ? this.endTime : null,
          state: this.status || null,
          type: this.baojing || null,
          /* deviceName: this.inpVal ? this.inpVal : null,
                        content: this.inpCon ? this.inpCon : null,*/
          deviceId: this.deviceDetailId,
          states: "0,1",
        };

        if (this.tableOption.blockType == "bj1") {
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            pageSize: 10,
            currentPage: this.currentPage,
            beginTime: this.beginTime ? this.beginTime : null,
            endTime: this.endTime ? this.endTime : null,
            state: 2,
            type: this.baojing || null,
            /*  deviceName: this.inpVal ? this.inpVal : null,
                            content: this.inpCon ? this.inpCon : null,*/
            deviceId: this.deviceDetailId,
            dateType: this.tableOption.dateType,
          };
        } else if (this.tableOption.blockType == "bj2") {
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            pageSize: 10,
            currentPage: this.currentPage,
            beginTime: this.beginTime ? this.beginTime : null,
            endTime: this.endTime ? this.endTime : null,
            state: this.status || null,
            type: this.baojing || null,
            /* deviceName: this.inpVal ? this.inpVal : null,
                            content: this.inpCon ? this.inpCon : null,*/
            deviceId: this.deviceDetailId,
            dateType: this.tableOption.dateType,
          };
        }
      } else if (
        this.tableOption.blockType == "yj" ||
        this.tableOption.blockType == "yj1" ||
        this.tableOption.blockType == "yj2"
      ) {
        //预警
        data.url = contBlockUrl.yjList;
        data.obj = {
          orgId: this.$store.state.baseInfoLayer.baseInfoId,
          pageSize: 10,
          currentPage: this.currentPage,
          beginTime: this.beginTime ? this.beginTime : null,
          endTime: this.endTime ? this.endTime : null,
          state: 0,
          type: this.baojing || null,
          deviceId: this.deviceDetailId,
          /* deviceName: this.inpVal ? this.inpVal : null,
                        content: this.inpCon ? this.inpCon : null,*/
        };

        if (this.tableOption.blockType == "yj1") {
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            pageSize: 10,
            currentPage: this.currentPage,
            beginTime: this.beginTime ? this.beginTime : null,
            endTime: this.endTime ? this.endTime : null,
            state: 2,
            type: this.baojing || null,
            /*deviceName: this.inpVal ? this.inpVal : null,
                            content: this.inpCon ? this.inpCon : null,*/
            deviceId: this.deviceDetailId,
            dateType: this.tableOption.dateType,
          };
        } else if (this.tableOption.blockType == "yj2") {
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            pageSize: 10,
            currentPage: this.currentPage,
            beginTime: this.beginTime ? this.beginTime : null,
            endTime: this.endTime ? this.endTime : null,
            state: null,
            type: this.baojing || null,
            /* deviceName: this.inpVal ? this.inpVal : null,
                            content: this.inpCon ? this.inpCon : null,*/
            deviceId: this.deviceDetailId,
            dateType: this.tableOption.dateType,
          };
        }
      } else if (
        this.tableOption.blockType == "gz" ||
        this.tableOption.blockType == "gz1" ||
        this.tableOption.blockType == "gz2"
      ) {
        //故障
        data.url = contBlockUrl.gzList;
        data.obj = {
          orgId: this.$store.state.baseInfoLayer.baseInfoId,
          pageSize: 10,
          currentPage: this.currentPage,
          beginTime: this.beginTime ? this.beginTime : null,
          endTime: this.endTime ? this.endTime : null,
          state: 0,
          type: this.guzhang || null,
          /* deviceName: this.inpVal ? this.inpVal : null,
                        content: this.inpCon ? this.inpCon : null,*/
          deviceId: this.deviceDetailId,
          source: this.eventSource || null,
        };

        if (this.tableOption.blockType == "gz1") {
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            pageSize: 10,
            currentPage: this.currentPage,
            beginTime: this.beginTime ? this.beginTime : null,
            endTime: this.endTime ? this.endTime : null,
            state: 2,
            type: this.guzhang || null,
            /*deviceName: this.inpVal ? this.inpVal : null,
                            content: this.inpCon ? this.inpCon : null,*/
            deviceId: this.deviceDetailId,
            dateType: this.tableOption.dateType,
            source: this.eventSource || null,
          };
        } else if (this.tableOption.blockType == "gz2") {
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            pageSize: 10,
            currentPage: this.currentPage,
            beginTime: this.beginTime ? this.beginTime : null,
            endTime: this.endTime ? this.endTime : null,
            state: null,
            type: this.guzhang || null,
            /*deviceName: this.inpVal ? this.inpVal : null,
                            content: this.inpCon ? this.inpCon : null,*/
            deviceId: this.deviceDetailId,
            dateType: this.tableOption.dateType,
            source: this.eventSource || null,
          };
        }
      } else if (
        this.tableOption.blockType == "xfz" ||
        this.tableOption.blockType == "xfz1" ||
        this.tableOption.blockType == "xfz2"
      ) {
        //消防主机
        data.url = contBlockUrl.xfzList;
        data.obj = {
          orgId: this.$store.state.baseInfoLayer.baseInfoId,
          pageSize: 50,
          name: this.inpVal ? this.inpVal : null,
          currentPage: this.currentPage,
        };

        if (this.tableOption.blockType == "xfz1") {
          //异常Echart
          data.url = contBlockUrl.deviceEchart;
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            // partStateCodes: '0,1,2,3,4',
            type: "0",
            mainframeId: this.hostId || null,
          };
        } else if (this.tableOption.blockType == "xfz2") {
          //正常点位
          data.url = contBlockUrl.deviceNormalList;
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            name: this.inpVal ? this.inpVal : null,
            buildingId: this.buildingId,
            floor: this.floor,
            pageSize: 50,
            currentPage: this.currentPage,
            partStateCodes: "5,0",
          };
        }
      } else if (
        this.tableOption.blockType == "dq" ||
        this.tableOption.blockType == "dq1" ||
        this.tableOption.blockType == "dq2"
      ) {
        //电气火灾
        data.url = contBlockUrl.deviceEchart_list;
        data.obj = {
          orgId: this.$store.state.baseInfoLayer.baseInfoId,
          pageSize: 50,
          name: this.inpVal ? this.inpVal : null,
          currentPage: this.currentPage,
          systemForms: 15,
          buildingId: this.buildingId,
          floor: this.floor,
          partStateCode: this.status,
        };

        if (this.tableOption.blockType == "dq1") {
          //异常Echart
          data.url = contBlockUrl.deviceEchart;
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            type: "3",
            systemForms: 15,
          };
        } else if (this.tableOption.blockType == "dq2") {
          //正常点位
          data.url = contBlockUrl.deviceEchart_list;
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            name: this.inpVal ? this.inpVal : null,
            buildingId: this.buildingId,
            floor: this.floor,
            pageSize: 50,
            currentPage: this.currentPage,
            partStateCodes: "0,5",
            systemForms: 15,
          };
        }
      } else if (
        this.tableOption.blockType == "qt" ||
        this.tableOption.blockType == "qt1" ||
        this.tableOption.blockType == "qt2"
      ) {
        //其他设备
        data.url = contBlockUrl.deviceEchart_list;
        data.obj = {
          orgId: this.$store.state.baseInfoLayer.baseInfoId,
          pageSize: 50,
          name: this.inpVal ? this.inpVal : null,
          currentPage: this.currentPage,
          systemForms: 99,
          buildingId: this.buildingId,
          floor: this.floor,
          partStateCode: this.status,
        };

        if (this.tableOption.blockType == "qt1") {
          //异常Echart
          data.url = contBlockUrl.deviceEchart;
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            type: "3",
            systemForms: 99,
            /* partStateCodes: '1'*/
          };
        } else if (this.tableOption.blockType == "qt2") {
          //正常点位
          data.url = contBlockUrl.deviceEchart_list;
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            name: this.inpVal ? this.inpVal : null,
            buildingId: this.buildingId,
            floor: this.floor,
            pageSize: 50,
            currentPage: this.currentPage,
            partStateCodes: "0,5",
            systemForms: 99,
          };
        }
      } else if (
        this.tableOption.blockType == "xfs" ||
        this.tableOption.blockType == "xfs1" ||
        this.tableOption.blockType == "xfs2"
      ) {
        //消防水设备
        data.url = contBlockUrl.deviceEchart_list;
        data.obj = {
          orgId: this.$store.state.baseInfoLayer.baseInfoId,
          pageSize: 50,
          name: this.inpVal ? this.inpVal : null,
          currentPage: this.currentPage,
          systemForms: "2,4",
          buildingId: this.buildingId,
          floor: this.floor,
          partStateCode: this.status,
        };

        if (this.tableOption.blockType == "xfs1") {
          //异常Echart
          data.url = contBlockUrl.deviceEchart;
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            type: "3",
            systemForms: "2,4",
          };
        } else if (this.tableOption.blockType == "xfs2") {
          //正常点位
          data.url = contBlockUrl.deviceEchart_list;
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            name: this.inpVal ? this.inpVal : null,
            buildingId: this.buildingId,
            floor: this.floor,
            pageSize: 50,
            currentPage: this.currentPage,
            partStateCodes: "0,5",
            systemForms: "2,4",
          };
        }
      } else if (
        this.tableOption.blockType == "tc" ||
        this.tableOption.blockType == "tc1" ||
        this.tableOption.blockType == "tc2"
      ) {
        //独立探测器
        data.url = contBlockUrl.deviceEchart_list;
        data.obj = {
          orgId: this.$store.state.baseInfoLayer.baseInfoId,
          pageSize: 50,
          name: this.inpVal ? this.inpVal : null,
          currentPage: this.currentPage,
          systemForms: 28,
          buildingId: this.buildingId,
          floor: this.floor,
          partStateCode: this.status,
        };

        if (this.tableOption.blockType == "tc1") {
          //异常Echart
          data.url = contBlockUrl.deviceEchart;
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            type: "3",
            systemForms: 28,
          };
        } else if (this.tableOption.blockType == "tc2") {
          //正常点位
          data.url = contBlockUrl.deviceEchart_list;
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            name: this.inpVal ? this.inpVal : null,
            buildingId: this.buildingId,
            floor: this.floor,
            pageSize: 50,
            currentPage: this.currentPage,
            partStateCodes: "0,5",
            systemForms: 28,
          };
        }
      } else if (
        this.tableOption.blockType == "zdmh" ||
        this.tableOption.blockType == "zdmh1" ||
        this.tableOption.blockType == "zdmh2"
      ) {
        //自动灭火系统
        data.url = contBlockUrl.deviceEchart_list;
        data.obj = {
          orgId: this.$store.state.baseInfoLayer.baseInfoId,
          pageSize: 50,
          name: this.inpVal ? this.inpVal : null,
          currentPage: this.currentPage,
          systemForms: 32,
          buildingId: this.buildingId,
          floor: this.floor,
          partStateCode: this.status,
        };

        if (this.tableOption.blockType == "zdmh1") {
          //异常Echart
          data.url = contBlockUrl.deviceEchart;
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            type: "3",
            systemForms: 32,
          };
        } else if (this.tableOption.blockType == "zdmh2") {
          //正常点位
          data.url = contBlockUrl.deviceEchart_list;
          data.obj = {
            orgId: this.$store.state.baseInfoLayer.baseInfoId,
            name: this.inpVal ? this.inpVal : null,
            buildingId: this.buildingId,
            floor: this.floor,
            pageSize: 50,
            currentPage: this.currentPage,
            partStateCodes: "0,5",
            systemForms: 32,
          };
        }
      } else if (this.tableOption.blockType == "kk") {
        //智能空开
      } else if (
        this.tableOption.blockType == "sp" ||
        this.tableOption.blockType == "sp1" ||
        this.tableOption.blockType == "sp2"
      ) {
        //智能空开
        data.url = contBlockUrl.deviceSpList;
        data.obj = {
          orgId: this.$store.state.baseInfoLayer.baseInfoId,
          pageSize: 50,
          currentPage: this.currentPage,
        };
        if (this.tableOption.blockType == "sp1") {
          data.obj["state"] = 1; //离线
        } else if (this.tableOption.blockType == "sp2") {
          data.obj["state"] = 0; //在线
        }
      } else if (this.tableOption.blockType == "xj") {
        //巡检
        data.url = contBlockUrl.deviceXjList;
        data.obj = {
          orgId: this.$store.state.baseInfoLayer.baseInfoId,
          pageSize: 50,
          currentPage: this.currentPage,
          deviceName: this.inpVal || null,
        };
      } else if (
        this.tableOption.blockType == "xc" ||
        this.tableOption.blockType == "xc1" ||
        this.tableOption.blockType == "xc2" ||
        this.tableOption.blockType == "xc3"
      ) {
        //人员管理 巡查检查

        data.url = contBlockUrl.xcList;
        let dataState = null;
        if (this.tableOption.blockType == "xc1") {
          //超期
          dataState = 2;
        } else if (this.tableOption.blockType == "xc2") {
          //进行
          dataState = 0;
        } else if (this.tableOption.blockType == "xc3") {
          //完成
          dataState = 1;
        }
        data.obj = {
          endTime: returnDay("next"),
          executeOrgId: this.$store.state.baseInfoLayer.baseInfoId,
          dataState: dataState,
          dateType: this.tableOption.dateType,
        };
      } else if (
        this.tableOption.blockType == "yh" ||
        this.tableOption.blockType == "yh1" ||
        this.tableOption.blockType == "yh2"
      ) {
        data.url = contBlockUrl.yhList;
        data.obj = {
          pageSize: 50,
          currentPage: this.currentPage,
          orgId: this.$store.state.baseInfoLayer.baseInfoId,
          beginTime: new Date(this.beginTime).getTime() || null,
          endTime: new Date(this.endTime).getTime() || null,
          state: "0",
          type: null,
          deviceName: this.inpVal ? this.inpVal : null,
          content: this.inpCon ? this.inpCon : null,
        };
        if (this.tableOption.blockType != "yh") {
          data.obj.beginTime = this.returnTimestamp(returnDay());
          data.obj.endTime = this.returnTimestamp(returnDay("next"));
          data.obj.dateType = this.tableOption.dateType;
        }
        if (this.tableOption.blockType == "yh1") {
          data.obj.state = 2;
          data.obj.dateType = this.tableOption.dateType;
        }
        if (this.tableOption.blockType == "yh2") {
          data.obj.state = null;
        }
      } else if (
        this.tableOption.blockType == "cg" ||
        this.tableOption.blockType == "cg1" ||
        this.tableOption.blockType == "cg2"
      ) {
        //查岗echarts图
        data.url = contBlockUrl.cgEchart;
        data.obj = {
          checkedOrgId: this.$store.state.baseInfoLayer.baseInfoId,
          result: null,
          dateType: this.tableOption.dateType,
        };
        if (this.tableOption.blockType == "cg") {
          data.obj.result = null;
        } else if (this.tableOption.blockType == "cg1") {
          data.obj.result = 0;
        } else if (this.tableOption.blockType == "cg2") {
          data.obj.result = 1;
          data.obj.orgId = this.comId || null;
        }
      } else if (this.tableOption.blockType == "cg3") {
        data.url = contBlockUrl.cgVideo;
        data.obj = {
          orgId: this.$store.state.baseInfoLayer.baseInfoId,
          pageSize: 50,
          currentPage: this.currentPage,
        };
      } else if (
        this.tableOption.blockType == "px" ||
        this.tableOption.blockType == "px1" ||
        this.tableOption.blockType == "px2" ||
        this.tableOption.blockType == "px3"
      ) {
        //培训echarts图
        data.url = contBlockUrl.pxEchart;
        data.obj = {
          executeOrgId: this.$store.state.baseInfoLayer.baseInfoId,
        };
        if (this.tableOption.blockType == "px1") {
          //超期
          data.obj = {
            name: this.inpVal ? this.inpVal : null,
            executeOrgId: this.$store.state.baseInfoLayer.baseInfoId,
            overtimeFlag: 1,
            taskStateCodes: "0,1",
          };
        } else if (this.tableOption.blockType == "px2") {
          //进行
          data.obj = {
            name: this.inpVal ? this.inpVal : null,
            executeOrgId: this.$store.state.baseInfoLayer.baseInfoId,
            overtimeFlag: 0,
            taskStateCodes: "0,1",
          };
        } else if (this.tableOption.blockType == "px3") {
          //完成
          data.obj = {
            name: this.inpVal ? this.inpVal : null,
            executeOrgId: this.$store.state.baseInfoLayer.baseInfoId,
            taskStateCode: 2,
          };
        }
      }
      _this.$Axios(data).then((res) => {
        // console.log(res);

        this.loading_status = false;
        if (res.data.success) {
          // console.log(res.data.data);
          if (res.data.totalCount) {
            _this.totalCount = res.data.totalCount;
          }
          if (!res.data.data.length) {
            this.noData = true; //无数据
          }
          if (
            _this.tableOption.blockType == "sp" ||
            _this.tableOption.blockType == "sp1" ||
            _this.tableOption.blockType == "sp2" ||
            _this.tableOption.blockType == "cg3"
          ) {
            _this.cardList = [..._this.cardList, ...res.data.data];
            _this.$nextTick(() => {
              $JQ("#base-layer-block-video").mCustomScrollbar({
                callbacks: {
                  onTotalScroll: function () {
                    if (
                      _this.cardList.length == res.data.totalCount ||
                      res.data.data.length == 0
                    ) {
                      console.log("没有更多数据");
                      return;
                    } else {
                      console.log("加载更多");
                      _this.currentPage += 1;
                      _this.getData();
                    }
                  },
                },
              });
            });
            return;
          }
          _this.setData(res.data.data);
        }
      });
    },
    setData(data) {
      console.log(data);
      if (
        this.tableOption.blockType == "xfz" ||
        this.tableOption.blockType == "xfz2"
      ) {
        //消防主机
        console.log("消防主机数据");
        this.tableListArr = [...this.tableListArr, ...data];
      } else if (this.tableOption.blockType == "xfz1") {
        //设置echarts图
        console.log("培训echarts图");
        this.setEchart(data);
      } else if (
        this.tableOption.blockType == "dq" ||
        this.tableOption.blockType == "dq2"
      ) {
        //电气火灾
        console.log("电气火灾数据");
        this.tableListArr = [...this.tableListArr, ...data];
      } else if (this.tableOption.blockType == "dq1") {
        //设置echarts图
        console.log("电气echarts图");
        this.setEchart(data);
      } else if (
        this.tableOption.blockType == "qt" ||
        this.tableOption.blockType == "qt2"
      ) {
        //电气火灾
        console.log("其他设备数据");
        this.tableListArr = [...this.tableListArr, ...data];
      } else if (this.tableOption.blockType == "qt1") {
        //设置echarts图
        console.log("其他设备echarts图");
        this.setEchart(data);
      } else if (
        this.tableOption.blockType == "xfs" ||
        this.tableOption.blockType == "xfs2"
      ) {
        //消防水设备
        console.log("消防水设备数据");
        this.tableListArr = [...this.tableListArr, ...data];
      } else if (this.tableOption.blockType == "xfs1") {
        //设置echarts图
        console.log("消防水设备echarts图");
        this.setEchart(data);
      } else if (
        this.tableOption.blockType == "tc" ||
        this.tableOption.blockType == "tc2"
      ) {
        //独立式探测器
        console.log("独立式探测器数据");
        this.tableListArr = [...this.tableListArr, ...data];
      } else if (
        this.tableOption.blockType == "zdmh" ||
        this.tableOption.blockType == "zdmh2"
      ) {
        //自动灭火系统
        console.log("自动灭火系统数据");
        this.tableListArr = [...this.tableListArr, ...data];
      } else if (this.tableOption.blockType == "tc1") {
        //设置echarts图
        console.log("独立式探测器echarts图");
        this.setEchart(data);
      } else if (
        this.tableOption.blockType == "hj" ||
        this.tableOption.blockType == "hj1" ||
        this.tableOption.blockType == "hj2"
      ) {
        //火警
        console.log("火警数据");
        this.tableListArr = [...this.tableListArr, ...data];
        //this.tableListArr = data;
        console.log(this.totalCount);
        console.log(this.tableListArr);
      } else if (
        this.tableOption.blockType == "bj" ||
        this.tableOption.blockType == "bj1" ||
        this.tableOption.blockType == "bj2"
      ) {
        //报警
        console.log("报警数据");
        this.tableListArr = [...this.tableListArr, ...data];
        // this.tableListArr = data;
        console.log(this.totalCount);
        console.log(this.tableListArr);
      } else if (
        this.tableOption.blockType == "yj" ||
        this.tableOption.blockType == "yj1" ||
        this.tableOption.blockType == "yj2"
      ) {
        //预警
        console.log("预警数据");
        this.tableListArr = [...this.tableListArr, ...data];
        // this.tableListArr = data;
      } else if (
        this.tableOption.blockType == "gz" ||
        this.tableOption.blockType == "gz1" ||
        this.tableOption.blockType == "gz2"
      ) {
        //故障
        console.log("故障数据");
        this.tableListArr = [...this.tableListArr, ...data];
        // this.tableListArr = data;
      } else if (
        this.tableOption.blockType == "xc" ||
        this.tableOption.blockType == "xc1" ||
        this.tableOption.blockType == "xc2" ||
        this.tableOption.blockType == "xc3"
      ) {
        console.log("巡检巡查数据");
        this.tableListArr = [...this.tableListArr, ...data];
        for (let i = 0; i < this.tableListArr.length; i++) {
          this.tableListArr[i].beginTime = this.timestamp(
            this.tableListArr[i].beginTime
          );
          this.tableListArr[i].endTime = this.timestamp(
            this.tableListArr[i].endTime
          );
        }
        // $('.block-detail .modal-wrap').mCustomScrollbar();
        this.$nextTick(() => {
          $JQ("#modal-wrap").mCustomScrollbar();
        });
      } else if (
        this.tableOption.blockType == "yh" ||
        this.tableOption.blockType == "yh1" ||
        this.tableOption.blockType == "yh2"
      ) {
        console.log("隐患数据");
        this.tableListArr = [...this.tableListArr, ...data];
      } else if (
        this.tableOption.blockType == "cg" ||
        this.tableOption.blockType == "cg1" ||
        this.tableOption.blockType == "cg2"
      ) {
        //设置echarts图
        console.log("查岗echarts图");
        this.setEchart(data);
      } else if (
        this.tableOption.blockType == "px" ||
        this.tableOption.blockType == "px1" ||
        this.tableOption.blockType == "px2" ||
        this.tableOption.blockType == "px3"
      ) {
        //设置echarts图
        console.log("培训echarts图");
        this.setEchart(data);
      } else if (this.tableOption.blockType == "xj") {
        //巡检
        console.log("巡检数据");
        this.tableListArr = [...this.tableListArr, ...data];
      } else if (
        this.tableOption.blockType == "sp" ||
        this.tableOption.blockType == "sp1" ||
        this.tableOption.blockType == "sp2"
      ) {
        console.log("视频数据");
      }
      this.tableInitStatus = true;
      this.$nextTick(() => {
        $JQ("#modal-table-body").mCustomScrollbar();
      });
    },
    echartDataReturn(data) {
      let dataArr = Object.keys(data);
      let data_arr = [];
      if (this.tableOption.blockType == "xfz1") {
        for (let i = 0; i < dataArr.length; i++) {
          let obj = {
            value: data[dataArr[i]],
            name:
              dataArr[i] == "lxStateCount"
                ? "离线"
                : dataArr[i] == "bjStateCount"
                ? "报警"
                : dataArr[i] == "yjStateCount"
                ? "预警"
                : "故障",
            itemStyle: {
              color:
                dataArr[i] == "lxStateCount"
                  ? "#5D7092"
                  : dataArr[i] == "bjStateCount"
                  ? "#4D7DDA"
                  : dataArr[i] == "yjStateCount"
                  ? "#4CE4AD"
                  : "#F6BD16",
            },
          };
          data_arr.push(obj);
        }
      } else if (
        this.tableOption.blockType == "dq1" ||
        this.tableOption.blockType == "xfs1" ||
        this.tableOption.blockType == "tc1" ||
        this.tableOption.blockType == "qt1"
      ) {
        for (let i = 0; i < dataArr.length; i++) {
          let obj = {
            value: data[dataArr[i]],
            name:
              dataArr[i] == "lxStateCount"
                ? "离线"
                : dataArr[i] == "bjStateCount"
                ? "报警"
                : dataArr[i] == "yjStateCount"
                ? "预警"
                : "故障",
            itemStyle: {
              color:
                dataArr[i] == "lxStateCount"
                  ? "#5D7092"
                  : dataArr[i] == "bjStateCount"
                  ? "#4D7DDA"
                  : dataArr[i] == "yjStateCount"
                  ? "#4CE4AD"
                  : "#F6BD16",
            },
          };
          data_arr.push(obj);
        }
      } else if (
        this.tableOption.blockType == "cg" ||
        this.tableOption.blockType == "cg1"
      ) {
        for (let i = 0; i < dataArr.length; i++) {
          let obj = {
            value: data[dataArr[i]],
            name:
              dataArr[i] == "check"
                ? "自查"
                : dataArr[i] == "checked"
                ? "被查"
                : "离岗",
            itemStyle: {
              color:
                dataArr[i] == "check"
                  ? "#F6BD16"
                  : dataArr[i] == "checked"
                  ? "#4D7DDA"
                  : "#5D7092",
            },
          };
          data_arr.push(obj);
        }
      } else if (this.tableOption.blockType == "cg2") {
        for (let i = 0; i < dataArr.length; i++) {
          if (dataArr[i] != "outStation") {
            let obj = {
              value: data[dataArr[i]],
              name: dataArr[i] == "check" ? "自查" : "被查",
              itemStyle: {
                color: dataArr[i] == "check" ? "#F6BD16" : "#4D7DDA",
              },
            };
            data_arr.push(obj);
          }
        }
      } else if (
        this.tableOption.blockType == "px" ||
        this.tableOption.blockType == "px1" ||
        this.tableOption.blockType == "px2" ||
        this.tableOption.blockType == "px3"
      ) {
        for (let i = 0; i < dataArr.length; i++) {
          let obj = {
            value: data[dataArr[i]],
            name: dataArr[i] == "drill" ? "演练" : "培训",
            itemStyle: {
              color: dataArr[i] == "drill" ? "#4D7DDA" : "#D1A419",
            },
          };
          data_arr.push(obj);
        }
      }
      this.echartClickTit = this.tableOption.title + "-" + data_arr[0].name;
      if (this.echartClickName) {
        this.echartClick(this.echartClickName);
      } else {
        this.echartClickName = data_arr[0].name;
        this.echartClick(data_arr[0].name); //默认点击第一个
      }
      return data_arr;
    },
    setEchart(data) {
      let dataKey = Object.keys(data);
      let dataKeyLength = 0;
      let dataObj = {};
      for (let i = 0; i < dataKey.length; i++) {
        if (data[dataKey[i]] == 0) {
          dataKey.splice(i, 1, "");
          dataKeyLength += 1;
        }
      }
      if (dataKeyLength == dataKey.length) {
        //如果所有的数据都为0
        dataObj = data;
      } else {
        //只显示有数据的echarts图
        for (let i = 0; i < dataKey.length; i++) {
          if (dataKey[i]) {
            dataObj[dataKey[i]] = data[dataKey[i]];
          }
        }
      }
      let _this = this;
      this.echartDom = this.$echarts.init(
        document.getElementById("ecahrts-wrap")
      );
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
          textStyle: {
            color: "#74d9ff",
          },
          confine: true,
        },
        grid: {
          left: "20%",
          right: "20%",
          bottom: "20%",
          top: "3%",
          containLabel: true,
        },
        series: [
          {
            name: this.tableOption.title,
            type: "pie",
            radius: [50, 100],
            data: this.echartDataReturn(dataObj),
            // roseType: "angle",
            label: {
              normal: {
                textStyle: {
                  color: "#74d9ff",
                },
              },
            },
            labelLine: {
              normal: {
                lineStyle: {
                  color: "#74d9ff",
                },
              },
            },
          },
        ],
      };
      this.$nextTick(() => {
        this.echartDom.setOption(option);
        this.echartDom.off("click");
        this.echartDom.on("click", function (params) {
          console.log(params);
          console.log(params.data.name);
          _this.echartClickTit =
            _this.tableOption.title + "-" + params.data.name;
          _this.echartClickName = params.data.name;
          _this.echartClick(params.data.name);
        });
      });
    },
    echartClick(name) {
      this.loading_status = true;
      this.noData = false;
      console.log(JSON.parse(window.localStorage.getItem("loginData")));
      this.sponsoredUnit = name;
      let params = {};
      var data = {
        type: "get",
        url: "",
        obj: {},
      };
      if (this.tableOption.blockType == "xfz1") {
        data.url = contBlockUrl.deviceNormalList;
        switch (name) {
          case "离线":
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              partStateCode: 1,
              mainframeId: this.hostId || null,
            };
            break;
          case "报警":
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              partStateCode: 2,
              mainframeId: this.hostId || null,
            };
            break;
          case "预警":
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              partStateCode: 3,
              mainframeId: this.hostId || null,
            };
            break;
          case "故障":
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              partStateCode: 4,
              mainframeId: this.hostId || null,
            };
            break;
        }
      } else if (this.tableOption.blockType == "cg") {
        switch (name) {
          case "自查":
            data.url = contBlockUrl.cgCheck;
            params = {
              checkedOrgId: this.$store.state.baseInfoLayer.baseInfoId,
              // startTime: this.returnTimestamp(returnDay()),
              userName: this.inpVal ? this.inpVal : null,
              dateType: this.tableOption.dateType,
            };
            break;
          case "被查":
            data.url = contBlockUrl.cgChecked;
            params = {
              checkedOrgId: this.$store.state.baseInfoLayer.baseInfoId,
              // startTime: this.returnTimestamp(returnDay()),
              userName: this.inpVal ? this.inpVal : null,
              dateType: this.tableOption.dateType,
            };
            break;
          case "离岗":
            data.url = contBlockUrl.yjList;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              pageSize: 1000,
              currentPage: 1,
              type: 206,
              source: 5,
              content: this.inpVal ? this.inpVal : null,
            };
            break;
        }
      } else if (this.tableOption.blockType == "cg1") {
        switch (name) {
          case "自查":
            data.url = contBlockUrl.cgCheck;
            params = {
              checkedOrgId: this.$store.state.baseInfoLayer.baseInfoId,
              // startTime: this.returnTimestamp(returnDay()),
              result: 0,
              userName: this.inpVal ? this.inpVal : null,
              dateType: this.tableOption.dateType,
            };
            break;
          case "被查":
            data.url = contBlockUrl.cgChecked;
            params = {
              checkedOrgId: this.$store.state.baseInfoLayer.baseInfoId,
              // startTime: this.returnTimestamp(returnDay()),
              result: 0,
              userName: this.inpVal ? this.inpVal : null,
              dateType: this.tableOption.dateType,
            };
            break;
          case "离岗":
            data.url = contBlockUrl.yjList;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              pageSize: 1000,
              currentPage: 1,
              type: 206,
              source: 5,
              content: this.inpVal ? this.inpVal : null,
            };
            break;
        }
      } else if (this.tableOption.blockType == "cg2") {
        switch (name) {
          case "自查":
            data.url = contBlockUrl.cgCheck;
            params = {
              checkedOrgId: this.$store.state.baseInfoLayer.baseInfoId,
              // startTime: this.returnTimestamp(returnDay()),
              result: 1,
              userName: this.inpVal ? this.inpVal : null,
              dateType: this.tableOption.dateType,
              orgId: this.comId || null,
            };
            break;
          case "被查":
            data.url = contBlockUrl.cgChecked;
            params = {
              checkedOrgId: this.$store.state.baseInfoLayer.baseInfoId,
              // startTime: this.returnTimestamp(returnDay()),
              result: 1,
              userName: this.inpVal ? this.inpVal : null,
              dateType: this.tableOption.dateType,
              orgId: this.comId || null,
            };
            break;
          case "离岗":
            data.url = contBlockUrl.yjList;
            params = {
              // orgId: this.$store.state.baseInfoLayer.baseInfoId,
              pageSize: 1000,
              currentPage: 1,
              type: 206,
              source: 5,
              content: this.inpVal ? this.inpVal : null,
              orgId: this.comId || null,
            };
            break;
        }
      } else if (this.tableOption.blockType == "px") {
        switch (name) {
          case "演练":
            data.url = contBlockUrl.px_ylList;
            params = {
              executeOrgId: this.$store.state.baseInfoLayer.baseInfoId,
              type: 2,
              title: this.inpVal ? this.inpVal : null,
              beginTime: this.beginTime ? this.beginTime : null,
              endTime: this.endTime ? this.endTime : null,
            };
            this.isYl = true;
            break;
          case "培训":
            data.url = contBlockUrl.pxList;
            params = {
              executeOrgId: this.$store.state.baseInfoLayer.baseInfoId,
              type: 1,
              title: this.inpVal ? this.inpVal : null,
              beginTime: this.beginTime ? this.beginTime : null,
              endTime: this.endTime ? this.endTime : null,
            };
            this.isYl = false;
            break;
        }
      } else if (this.tableOption.blockType == "px1") {
        switch (name) {
          case "演练":
            data.url = contBlockUrl.px_ylList;
            params = {
              executeOrgId: this.$store.state.baseInfoLayer.baseInfoId,
              type: 2,
              overtimeFlag: 1,
              taskStateCodes: "0,1",
              title: this.inpVal ? this.inpVal : null,
              beginTime: this.beginTime ? this.beginTime : null,
              endTime: this.endTime ? this.endTime : null,
            };
            this.isYl = true;
            break;
          case "培训":
            data.url = contBlockUrl.pxList;
            params = {
              executeOrgId: this.$store.state.baseInfoLayer.baseInfoId,
              type: 1,
              overtimeFlag: 1,
              taskStateCodes: "0,1",
              title: this.inpVal ? this.inpVal : null,
              beginTime: this.beginTime ? this.beginTime : null,
              endTime: this.endTime ? this.endTime : null,
            };
            this.isYl = false;
            break;
        }
      } else if (this.tableOption.blockType == "px2") {
        switch (name) {
          case "演练":
            data.url = contBlockUrl.px_ylList;
            params = {
              executeOrgId: this.$store.state.baseInfoLayer.baseInfoId,
              type: 2,
              overtimeFlag: 0,
              taskStateCodes: "0,1",
              title: this.inpVal ? this.inpVal : null,
              beginTime: this.beginTime ? this.beginTime : null,
              endTime: this.endTime ? this.endTime : null,
            };
            this.isYl = true;
            break;
          case "培训":
            data.url = contBlockUrl.pxList;
            params = {
              executeOrgId: this.$store.state.baseInfoLayer.baseInfoId,
              type: 1,
              overtimeFlag: 0,
              taskStateCodes: "0,1",
              title: this.inpVal ? this.inpVal : null,
              beginTime: this.beginTime ? this.beginTime : null,
              endTime: this.endTime ? this.endTime : null,
            };
            this.isYl = false;
            break;
        }
      } else if (this.tableOption.blockType == "px3") {
        switch (name) {
          case "演练":
            data.url = contBlockUrl.px_ylList;
            params = {
              executeOrgId: this.$store.state.baseInfoLayer.baseInfoId,
              type: 2,
              taskStateCode: 2,
              title: this.inpVal ? this.inpVal : null,
              beginTime: this.beginTime ? this.beginTime : null,
              endTime: this.endTime ? this.endTime : null,
            };
            this.isYl = true;
            break;
          case "培训":
            data.url = contBlockUrl.pxList;
            params = {
              executeOrgId: this.$store.state.baseInfoLayer.baseInfoId,
              type: 1,
              taskStateCode: 2,
              title: this.inpVal ? this.inpVal : null,
              beginTime: this.beginTime ? this.beginTime : null,
              endTime: this.endTime ? this.endTime : null,
            };
            this.isYl = false;
            break;
        }
      } else if (this.tableOption.blockType == "dq1") {
        switch (name) {
          case "离线":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: 15,
              partStateCode: 1,
            };
            break;
          case "报警":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: 15,
              partStateCode: 2,
            };
            break;
          case "预警":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: 15,
              partStateCode: 3,
            };
            break;
          case "故障":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: 15,
              partStateCode: 4,
            };
            break;
        }
      } else if (this.tableOption.blockType == "qt1") {
        switch (name) {
          case "离线":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: 99,
              partStateCode: 1,
            };
            break;
          case "报警":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: 99,
              partStateCode: 2,
            };
            break;
          case "预警":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: 99,
              partStateCode: 3,
            };
            break;
          case "故障":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: 99,
              partStateCode: 4,
            };
            break;
        }
      } else if (this.tableOption.blockType == "xfs1") {
        switch (name) {
          case "离线":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: "2,4",
              partStateCode: 1,
            };
            break;
          case "报警":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: "2,4",
              partStateCode: 2,
            };
            break;
          case "预警":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: "2,4",
              partStateCode: 3,
            };
            break;
          case "故障":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: "2,4",
              partStateCode: 4,
            };
            break;
        }
      } else if (this.tableOption.blockType == "tc1") {
        switch (name) {
          case "离线":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: 28,
              partStateCode: 1,
            };
            break;
          case "报警":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: 28,
              partStateCode: 2,
            };
            break;
          case "预警":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: 28,
              partStateCode: 3,
            };
            break;
          case "故障":
            data.url = contBlockUrl.deviceEchart_list;
            params = {
              orgId: this.$store.state.baseInfoLayer.baseInfoId,
              name: this.inpVal ? this.inpVal : null,
              buildingId: this.buildingId,
              floor: this.floor,
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: 28,
              partStateCode: 4,
            };
            break;
        }
      }
      data.obj = params;
      this.$Axios(data).then((res) => {
        //console.log(res);
        this.loading_status = false;
        if (res.data.success) {
          if (!res.data.data.length) {
            this.noData = true;
            return;
          }
          // console.log(res);
          console.log("-------");

          this.tableListArr = res.data.data;
          this.tableInitStatus = true;
          this.$nextTick(() => {
            $JQ("#modal-table-body").mCustomScrollbar();
          });
        }
      });
    },
    getTypeL() {
      var data = {
        type: "get",
        url: contBlockUrl.bjType,
        obj: {
          currentPage: 1,
          pageSize: 1000,
          exceptionType: 2,
        },
      };
      this.$Axios(data).then((res) => {
        // console.log(res.data.data);
        this.bjTypeList = res.data.data;
      });
    },
    getyjTypeL() {
      var data = {
        type: "get",
        url: contBlockUrl.yjGzType,
        obj: {
          currentPage: 1,
          pageSize: 1000,
          exceptionType: 1,
        },
      };
      this.$Axios(data).then((res) => {
        //console.log(res.data.data);
        this.yjTypeList = res.data.data;
      });
    },
    getGzTypeL() {
      var data = {
        type: "get",
        url: contBlockUrl.yjGzType,
        obj: {
          currentPage: 1,
          pageSize: 1000,
          exceptionType: 3,
        },
      };
      this.$Axios(data).then((res) => {
        console.log(res.data.data);
        this.guZList = res.data.data;
      });
    },
    getBuildings() {
      var data = {
        type: "get",
        url: buildings.yjGzType,
        obj: {
          currentPage: 1,
          pageSize: 1000,
        },
      };
      this.$Axios(data).then((res) => {
        console.log(res.data.data);
        this.buildList = res.data.data;
      });
    },
    showImg(imgSrc) {
      if (!imgSrc) {
        return;
      }
      this.modalShow = true;
      this.showVideo = false;
      this.modalImgSrc = imgSrc;
    },
    beforeDestroy() {
      this.videoDispose();
    },
    pxDetail(taskId) {
      if (this.sponsoredUnit == "演练") {
        this.optionBtnIndex = 8;
      } else if (this.sponsoredUnit == "培训") {
        this.optionBtnIndex = 9;
      }
      this.taskId = taskId;
    },
    xcDeatil(name, id) {
      this.deviceName = name;
      this.deviceId = id;
      this.optionBtnIndex = 10;
    },
    //放大镜在线离岗事件,//在岗 1 脱岗 0
    onDuty(value) {
      var endTime = getDate(new Date().getTime(), "year");
      var data = {
        type: "post",
        url: "mcbw/inspect_records",
        obj: {
          currentPage: 1,
          pageSize: 1000,
          result: value,
          cameraCode: this.cameraCode,
          startTime: this.startTime,
          endTime: endTime,
          checkedOrgId: this.checkedOrgId,
          user: this.loginData.userName,
          orgId: this.loginData.orgId,
          userId: this.loginData.id,
        },
      };
      this.$Axios(data).then((res) => {
        if (res) {
          this.$Message.success(res.data.message);
          //传给父组件
          this.$emit("todayCg", "");
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.block-detail {
  display: flex;
  // transition: all .3s;
  height: 520px;
  overflow-y: auto;
  margin-top: 5px;
  .detail_tit_wrap {
    display: flex;
    align-items: center;
    button {
      margin-left: 10px;
    }
  }
  .block_tit {
    font-size: 16px;
    font-weight: 600;
    // min-width: 300px;
    color: #74d9ff;
    position: relative;
    border-image: linear-gradient(90deg, #74d9ff 0, transparent 100%) 30 30;
    &:after {
      content: "";
      display: block;
      position: absolute;
      width: 35px;
      left: 10px;
      bottom: 0px;
      border-bottom: 4px solid #74d9ff;
    }
  }
  .ecahrts-wrap {
    width: 400px;
    height: 400px;
    margin-right: 10px;
    .head-option {
      height: 32px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      // .title {
      //     line-height: 32px;
      //     font-size: 14px;
      //     color: #08f4f7;
      // }
    }
    #ecahrts-wrap {
      height: 300px;
      margin-top: 20px;
    }
  }
  .modal-wrap {
    flex: 1;
    flex-shrink: 0;
    // overflow: hidden;
    display: flex;
    flex-direction: column;
    .option-wrap {
      .common-option {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .xc-wrap {
          width: 100%;
          .tit_wrap {
            display: flex;
            align-items: center;
            .sub-tit {
            }
            .checkList {
              margin-left: 20px;
            }
          }
          ul {
            width: 100%;
            li {
              float: left;
              width: 100%;
              position: relative;
              margin-bottom: 10px;
              .blockH60 {
                margin-right: 10px;
              }
              .info-progress {
                display: inline-block;
              }
              .info-time {
                display: inline-block;
                /*width: 400px;*/
                position: absolute;
                right: 0;
              }
            }
          }
          .xc-list-block-wrap {
            .block {
              span {
                color: #fff;
              }
            }
          }
        }
        .sub-tit {
          font-size: 16px;
          color: #74d9ff;
          margin: 10px 0;
        }
        .xc-list-block-wrap {
          width: 100%;
        }
      }
      // span {
      //     font-size: 14px;
      //     color: #ffffff;
      // }
      .form-wrap {
        display: flex;
      }
    }
    table {
      td {
        i.imgView {
          color: rgba(125, 180, 219, 0.7);
          cursor: pointer;
          &.active {
            color: rgba(125, 180, 219, 0.3);
            cursor: default;
          }
        }
        .td-option-wrap {
          display: flex;
          align-items: center;
          justify-content: center;
          i {
            margin: 0 10px;
            color: rgba(125, 180, 219, 0.3);
            cursor: default;
            &.active {
              color: rgba(125, 180, 219, 1);
              cursor: pointer;
            }
          }
        }
        .info-btn {
          cursor: pointer;
        }
        .option-wrap {
          display: flex;
          justify-content: center;
          span,
          i {
            margin: 0 5px;
            cursor: pointer;
            font-size: 16px;
            color: #74d9ff;
            color: rgba(225, 225, 225, 0.9);
          }
        }
      }
    }
    .common-table-body.nodata {
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #74d9ff;
    }
    .more-btn-wrap {
      height: 40px;
      display: flex;
      align-items: center;
      .btn {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #74d9ff;
        padding-left: 10px;
        cursor: pointer;
        i {
          margin: 0 10px;
        }
      }
    }
    .loading {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.3);
      img {
        width: 200px;
      }
    }
  }
}

.modalImg {
  width: 500px;
  margin: 0 auto;
}
.xfVideo {
  display: block;
  margin: 0 auto;
}
.progress {
  width: 350px;
}

.point {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.block {
  border-radius: 5px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
}

/deep/ .ivu-select-single .ivu-select-input {
  color: #74d9ff;
}

.colorPrimary {
  color: #2d8cf0;
}

.colorError {
  color: #ed4014;
}

.colorSuccess {
  color: #19be6b;
}

.bgPrimary {
  background: #2d8cf0;
}

.bgYellow {
  background: #f7c177;
}

.bgOrange {
  background: #f2a077;
}

.bgOrangeBig {
  background: #de713f;
}

.bgRed {
  background: #ef7f79;
}

.bgRedBig {
  background: #ed4014;
}

.bgGreen {
  background: #5995a9;
}

.bgGreenBig {
  background: #19be6b;
}

.bgPurple {
  background: #483ea2;
}

.bgGrey {
  background: #a4a4a4;
}

.bgGreyBig {
  background: #bcc5c7;
}

.colorGrey {
  color: #a4a4a4;
}

.colorWhite {
  color: #fff;
}

.colorGreyWeight {
  color: #787878;
}

.colorBlack {
  color: #515a6e !important;
}

.icon-wrap {
  .ivu-icon {
    background: #108de9;
    padding: 3px;
    color: #fff;
    margin-left: 10px;
    cursor: pointer;
  }
}

.disable-icon-wrap {
  .ivu-icon {
    background: #bcc5c7;
    cursor: not-allowed;
  }
}
.video-card-list {
  .video-list {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    .list-item-wrap {
      width: 25%;
      padding: 15px 10px 10px;
      display: inline-block;
      .list-item {
        border-radius: 10px;
        overflow: hidden;
        transition: all 0.2s ease-in-out;
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
        &:hover {
          transform: scale(1.1);
        }
        .video-box {
          position: relative;
          height: 0;
          padding-top: 60%;
          overflow: hidden;
          background: #f9f9f9;
          .cover {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
          video {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: fill;
            background: #333;
          }
          .item-video {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
        }
        .item-title-box {
          padding: 5px 0;
          background: rgba(43, 63, 73, 1);
          .item-title {
            display: flex;
            justify-content: space-between;
            padding: 0 10px;
            p {
              max-width: 50%;
              height: 24px;
              line-height: 24px;
              font-size: 12px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              transform: translate3d(0, 0, 0);
            }
          }
        }
      }
    }
  }
}
.onDutySty {
  display: inline-flex;
  justify-content: center;
  margin-top: 9px;
  .btnOne {
    margin-right: 20px;
  }
}
.ivu-dropdown {
  border: 1px solid #146c77;
  border-color: rgba(8, 244, 247, 0.3);
  background-color: hsla(0, 0%, 100%, 0.1);
  border-radius: 4px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
/deep/ .contentMohu {
  .ivu-input {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
}
.list-wrap {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
  // padding: 20px 0 20px 20px;
  display: flex;
  flex-direction: column;
  .search-group-wrap {
    // margin-bottom: 25px;
    display: flex;
    flex-direction: row;
    .input-wrap {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
    }
  }
  .result-wrap {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}
/deep/ .mCSB_scrollTools {
  right: 0 !important;
  .mCSB_dragger {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    .mCSB_dragger_bar {
      width: 8px;
    }
  }
  .mCSB_draggerRail {
    background-color: transparent;
  }
}
.video-title {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  color: #fff;
  line-height: 40px;
  align-items: center;
  .video-btn {
    display: flex;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/base-layer-block-detail.vue